export default {
    appTitle: "ISUPO",
    version: "Version",
    attachment: "Attachment",
    backToLogin: "Back to Login",
    test: "Test",
    email: "Email",
    link: 'Link',
    vatNumberUnique: "VAT number already exist. Name: {name}",
    companyNameUnique: "Company name already exist",
    password: "Password",
    passworRequirement:
        "Password must be at least 6 symbols and must contains lower character and a number. (Allowed special characters: @$!%*?&#-+<>`~()^=/\\)",
    passworConfirm:
        "The confirm password field does not match the Password field",
    confirmPassword: "Confirm Password",
    userName: "Username",
    login: "Login",
    resetPassword: "Change password",
    resetForgottenPassword: "Change forgotten password",
    logout: "Logout",
    register: "Register",
    important: "Important!",
    registerEmailInfo: "The entered e-mail will be used to log in to the @:appTitle .",
    registerMoodleEmailUsage: "If you are registered in the NIJ E-learning portal, please use the same e-mail address here.",
    registerPasswordHelp:
        "The password must be a minimum of 6 characters and must contains at least one lowercase Latin letter and a number. (Allowed special characters: @$!%*?&#-+<>`~()^=/\\)",
    consent: "With the registration you consent NIJ to use personal data for the purpose of the education.",
    choose: "Choose",
    save: "Save",
    backToRegister: "Back to register",
    unauthorizedMessage: "You are not authorized",
    lectors: "Lecturers",
    participants: "participants",
    organizers: "Organizers/Partners",
    details: "Details",
    description: "Description",
    personalData: "Personal data",
    passedTrainings: "Преминали обучения",
    foreignLanguagesProficiency: "Foreign languages proficiency",
    certificatesTitle: "Certificates",
    attachedDocuments: "Attached documents",
    addFile: "Add file",
    downloadFile: "Download file",
    remainingSymbols: "Symbols remaining:",
    today: "Today",
    yes: "Yes",
    no: "No",
    from: "From",
    to: "To",
    add: "Add",
    remove: "Remove",
    contactPerson: "Contact person",
    visible: "Vidible",
    unvisible: "Unvisible",
    personalSettingsLoaded: "Loaded",
    createSuccess: "Successfully created!",
    updateSuccess: "Successfully updated!",
    deleteSuccess: "Successfully deleted!",
    backToList: "Back to the list",
    backToRelatedEvent: "Back to the related event",
    backToFormsList: "Back to the forms list",
    vatCheckTitle: "VAT number validation",
    nomenclatureEditor: "Nomenclatures edition",
    foreignCitiesEdit: "Edit foreign cities",
    eventThemeEditor: "Event themes",
    select: "Select",
    documents: "Documents",
    document: "Document",
    documentsSettings: {
        documentType: "Document type",
        types: {
            businessTripOrder: "Business trip order",
            order: "Order",
            contract: "Contract",
            request: "Request",
            miscellaneous: "Miscellaneous"
        }
    },
    selectFiles: "Select files",
    selectNomenclature: "Select nomenclature ...",
    selectThematicArea: "Select a theme area ...",
    selectParticipationType: "Select participation type ...",
    selectCategory: "Select a category ...",
    selectBenchmark: "Select a benchmark type ...",
    selectTariffGroup: "Select a tariff group...",
    selectContract: "Select a contract ...",
    selectProperty: "Select a property ...",
    selectEvent: "Select an event ...",
    clientCertLogin: "QES login",
    forgottenPassword: "Forgotten password",
    forgottenPasswordOk:
        "The link for resetting the password was sent to the input email",
    forgottenPasswordError: "Error on sending a forgotten password link",
    forgottenPasswordIsReset: "You successfully changed your password",
    seeMore: "See more",
    seeLess: "See less",
    my: "Mine",
    all: "All",
    learningActivity: "Educational activity",
    eventsMap: "Events map",
    eventsMapCtrlZoomHint: "Zoom: Ctrl + scroll",
    otherActivities: "Other activities",
    insufficientRights:
        "You have insufficient rights to access this resources.",
    invalidAction: "Invalid action!",
    seeDownloadedFile: "See the downloaded file",
    missingSource: "Missing valid source.",
    missingData: "Missing data.",
    sync: "Synchronous",
    async: "Asynchronous",
    text: "Text",
    request_n: "Request",
    lastUpdatedBy: "Last updated by",
    lastUpdatedOn: "Last updated on",
    createdBy: "Created by ",
    createdOn: "Created on",
    filesUpload: "Documents",
    hours: "hours",
    minutes: "minutes",
    hoursAbbr: "h.",
    minutesAbbr: "min.",
    namePromptTitle: "Please enter a name.",
    noData: "No data",
    isNotUniqueNumber: "Identification number is not unique",
    isNotValidEgn: "Identification number is not valid",
    outOfActivityRange: "Out of activity range!",
    historicalData: "Historical data",
    forgotPasswordEmailHelpMessage: `Registered user's email`,
    invalidEmail: "Invalid email",
    missingProfile:
        "Missing profile data! Please enter personal information in your profile.",
    activeFormCheck: "Checking the activity and eligibility of the form.",
    activeFormCheckError:
        "An error occurred while checking the activity and eligibility of the form.",
    actions: 'Actions',
    of: 'of',
    items: 'items',
    emptySearchFilter: 'Empty search filter',
    records: 'record | records',
    administration: {
        user: {
            title: "User administration | Users administration",
            grid: {
                title: "Users"
            },
            confirmations: {
                delete: "Are you sure you want to delete user ",
                edit: "Are you sure you want to edit user ",
                relatedPersonDelete:
                    "Are you sure you want to remove the related person ",
                relatedPersonAdd:
                    "Are you sure you want to bind the selected person ",
                mergedPersonRemove:
                    "Are you sure you want to remove the merged person ",
                mergedPersonAdd: "Are you sure you want to merged Person "
            },
            lastLogTime: "Time of the last recorded action: ",
            relatedPerson: "Related Person",
            missingRelatedPerson: "Missing related person",
            signatureImage: "Signature image",
            canSignDocument: "Document signing"
        },
        userRoles: {
            title: "User groups"
        },
        import: {
            title: "Import",
            fileHelperMessage:
                "The service expects an Excel file with three obligatory columns, namely: "
        },
        person: {
            title: "Person | Persons",
            searchFormMerged: "Include merged profiles in the search",
            isParent: 'Parent person',
            noneParentSelected: 'None parent person has been selected.',
            emptySelection: "Selected persons are missing.",
            confirmations: {
                unmerge: 'Are you sure you want to remove the personality union of the "{person}"?'
            }
        },
        profile: {
            merge: "Merged profile | Merged profiles"
        }
    },
    sideMenu: {
        home: "Home",
        planning: "Planning",
        annualCatalogProject: "Annual catalog project",
        events: "Events",
        users: "Users",
        persons: "Persons",
        roles: "Roles",
        notifications: "System messages",
        claims: "Claims",
        rooms: "Rooms",
        tasks: "Tasks",
        tasksAndCoordinations: "Tasks and coordinations|Tasks, coordinations, signing",
        coordinations: "Coordinations",
        certificates: "Certificates",
        registers: "Registers",
        reports: "Reports",
        administration: "Administration",
        participants: "Participants",
        telerikGrid: "Telerik grid",
        list: "List",
        test: "Test",
        dynamicRegisters: "Dynamic registers administration",
        fieldTypes: "Field types",
        registerTypes: "Register types",
        dynamicRegisterEditor: "Editor",
        dynamicRegisterEditorTest: "Dynamic reg test",
        staticRegistersForDropdown: "Static registers for dropdown",
        panelsFields: "Panels/Fields",
        placesScheduler: "Places scheduler",
        lectors: "Lecturers",
        employees: "NIJ Employees",
        mentors: "Mentors",
        forms: "Forms",
        tariffs: "Tariffs",
        formsAndSurveys: "Forms and surveys",
        proposals: "Proposals",
        thematicArea: "Thematic area",
        formActivation: "Forms templating",
        all: "All",
        annualCatalog: "Annual catalog",
        reasonForAdmission: "Reason for admission / non-admission",
        allAppearances: "All appearances",
        calendar: "Calendar",
        agenda: "Agenda",
        presenceForm: "Presence form",
        budgetTemplate: "Budget templates",
        eventStatus: "Event status",
        documents: "Documents",
        participantsClaims: "Event participants permissions",
        reportData: "Data for reports",
        forum: "Forum",
        nomenclatureTypes: "Nomenclature types",
        participationType: "Participation type",
        benchmarkType: "Benchmark type",
        eventSubscriptions: "Event subscriptions",
        releaseInfo: "Release information",
        templates: "Templates",
        lecturersElectronicRegister:
            "An electronic register of professors from the judiciary",
        budgetModule: "Budget module",
        budgetModuleReport: "Budget module - report",
        usergroups: "User groups",
        usergroup: "User group",
        localization: "Labels text",
        participationRelationType: "Ground for participation",
        applicationSettings: "ApplicationSettings",
        rankingCriteria: "Ranking criteria",
        sentEmails: "Sent emails",
        archivedEvents: "Archived events",
        fieldCodes: "Field codes",
        auxiliaryRegister: "Auxiliary registers",
        help: "@:help.title",
        migrationCheck: "Migration check",
        signing: "Signing procedures",
        signatures: "Signatures",
        company: "Companies",
        deletedRecords: "Deleted records",
        signingProcedureFiling: "Filing of signature procedures",
    },
    dynamicDropdown: {
        noDataFound: "No data found for:",
        goToSection: "To create an entry go to:"
    },
    validation: {
        requiredField: "The field is required",
        uniqueField: "The field is unique",
        readOnlyField: "The field is readonly",
        defaultTextValue: '"Default value" field can`t be empty',
        invalidIntNumber: "The value is not valid integer number",
        invalidDecimalNumber: "The value is not valid real number",
        invalidDecimalPrecision: "The value has to be in range [0-18]",
        ivalidMinMaxValue: "The maximum value must be greater than the minimum",
        themeProposalUniqueName: 'The theme exists in selected year'
    },
    userManagement: {
        title: "User management",
        user: "User",
        users: "Users",
        roles: "Roles",
        info: {
            li1:
                "It is allowed to bind a Person who is not bound to another user.",
            li2:
                "It is allowed to bind a Person who is not united (not a child) with another Person.",
            li3:
                "When a Person is bound to a user and an existing one already bound to that user, the old one will merge with the new one, ie. will become her child.",
            li4:
                "All personalities added to a person already associated with this user, if any, will be united to the new personality (they will become children of the new Person)."
        }
    },
    externalServices: {
        title: "External services",
        updateCountries: "Countries nomenclature update",
        updateDistricts: "Districts nomenclature update",
        updateCities: "Settlements nomenclature update",
        updateResorts: "Resorts nomenclature update",
        migrateEvents: "Events migration",
        updateMoodleCategories: "Moodle categories update",
        clearCache: "Cache clear",
        eventsStaticContentSync: "Sync static content of events",
        migrateActivities: 'Migration of nomenclature "Activity"',
        migrateDirectorates: 'Migration of nomenclature "Directorate"',
        migratePositions: 'Migration of nomenclature "Position"',
        migrateStatPositions: 'Migration of nomenclature "Statistics Position"/"Professional category"',
        migrateEmployment: 'Migration of nomenclature "Employment"',
        migrateProjectName: 'Migration of nomenclature "Project name"',
        migrateInstitutions: 'Migration of nomenclature "Institution"',
        migrateFundingType: 'Migration of nomenclature "Funding type"',
        migrateParticipationType:
            'Migration of nomenclature "Participation type"',
        migrateLegalArea: 'Migration of nomenclature "Legal area"',
        migrateEventType: 'Migration of nomenclature "Event type"',
        migrateEventStatus: 'Migration of nomenclature "Event status"',
        migrateThematicArea: 'Migration of nomenclature "Thematic area"',
        migrateEventTheme: 'Migration of nomenclature "Event theme"',
        migrateReasonForParticipation:
            'Migration of nomenclature "Reason for participation"',
        migrateEducation: 'Migration of nomenclature "Education"',
        migrateTitle: 'Migration of nomenclature "Title/Degree"',
        migrateOrganizor: 'Migration of nomenclature "Organizor"',
        migratePlaces: 'Migration of nomenclature "Place"',
        migrateParticipants: "Participants migration",
        migrateLecturers: "Lecturers migration",
        syncLangJsFilesToTheDb: "Save the js localization files to the DB",
        testMoodleDbConnection: "Test Moodle DB connection"
    },
    nipData: {
        title: "National institute of justice",
        companyData: "National institute of justice company data"
    },
    notificationConfig: {
        title: "System message",
        config: "Configuration",
        type: "Event type",
        subject: "Message subject",
        content: "Message content",
        keywordsDescription:
            "You can use the following keywords when filling in the free text below, they will be replaced with object data: "
    },
    documentsRelation: {
        id: "Id",
        name: "File name",
        documentExtension: "File extension",
        documentType: "Document type",
        title: "Documents",
        type: "Type",
        event: "Event",
        createdOn: "Created on",
        createdBy: "Created by"
    },
    person: {
        cloneManager: "Manager data clone",
        cloneContact: "Contact person data clone",
        resetManager: "Reset",
        resetContact: "Reset",
        removeManager: "Remove Manager",
        addManager: "Add Manager",
        removeContact: "Remove Contact",
        addContact: "Add Contact",
        title: "Personal Information",
        firstName: "Name",
        middleName: "Middle Name",
        lastName: "Last Name",
        firstNameEn: "First Name (En)",
        middleNameEn: "Middle Name (En)",
        lastNameEn: "Last Name (En)",
        phone: "Phone",
        mobilePhone: "Mobile phone",
        idCardNumber: "ID Card",
        idCardDateOfIssue: "Date of issue",
        idCardIssuedBy: "Issued by",
        egn: "UCN",
        egnManager: "UCN - Manager",
        position: "Position",
        positionFullName: "Position full name",
        positionStatistic: "Professional category",
        description: "Description",
        identification: "Person identification",
        gender: "Gender",
        contactAddress: "Contact address",
        livingAddress: "Living address",
        gridTitle: "Person",
        gridHeaders: {
            id: "Id",
            fullname: "Name",
            identification: "Identification №",
            identificationType: "Identification type",
            username: "Username",
            parent: "Parent record",
            hasChanges: "Changes",
            email: "E-mail",
            roles: "User Groups",
            deleted: "Deleted",
            firstName: "First Name",
            middleName: "Middle Name",
            lastName: "Last Name",
            hasParent: "Has parent record",
            parentId: "Parent Id",
            updatedAtUtc: "Date of last update",
            updatedBy: "Last updated by"
        },
        participation: "Participation",
        certificates: "Certificates",
        changePassword: "Change password",
        edit: "Person edit",
        create: "Person create",
        salutation: "Salutation",
        titleDegree: "Title / Degree",
        educationDegree: "Education",
        institution: "Institution",
        institutionLocation: "Institution location",
        relatedToUser: "Related to user",
        specifyInstitution: "Specify another institution",
        country: "City",
        settlement: "City",
        confirmations: {
            edit: "Are you sure you want to edit ",
            create: "Are you sure you want to create ",
            delete: "Are you sure you want to delete "
        },
        tasks: "Tasks",
        help: {
            institutionHelp: "Search by institution name"
        },
        moodleAccountDetails: "Moodle account details",
        moodleAccountLinkLabel: "Moodle account Url",
        accountSyncedWithMoodle: "Synced with Moodle",
        moodleAccountSyncResult: "Moodle sync details",
        deleteMoodleSync: "Delete Moodle sync",
        userExistingInMoodleButNotSynced: "Moodle has an user with email: {email}, but no synchronization with the ISUPO has been made.",
        notAllFoundRecordsDiplayed: "Not all results are displayed. In order to see all results, please use more concrete filter.",
        createMoodleAccountHelp: "A new user profile will be created for you on the site \"Portal for e-learning of the National Institute of Justice\" with a <b> new temporary password </b>. More information will be sent to the relevant e-mail."
    },
    eventSubscriptions: {
        gridHeaders: {
            id: "Subscription Id",
            eventId: "Event Id",
            eventName: "Event",
            eventStartDate: "Start Date",
            eventEndDate: "End Date",
            eventSubscriptionStartDate: "Subscription Start Date",
            eventSubscriptionEndDate: "Subscription End Date",
            notificationTypeName: "Notification Type",
            userName: "Use Name",
            email: "Email",
            note: "Notes",
            createdAt: "Subscribed At"
        }
    },
    changePassword: {
        oldPassword: "Old password",
        newPassword: "New password",
        newPasswordConfirm: "New password confirmation",
        title: "Change password"
    },
    address: {
        cardTitle: "Address",
        cloneRegistrationAddress: "Registration address data clone",
        cloneContactAddress: "Correspondence address data clone",
        postCode: "Post code",
        settlement: "City(BG)",
        settlementEn: "City",
        country: "Country(BG)",
        countryEn: "Country",
        street: "Street",
        streetNum: "№",
        coords: "Coordinates",
        long: "Longitude",
        lat: "Latitude",
        areaOfAppeal: "Area of Appeal",
        settlementIdHelper: "Nomenclature of the settlements in Bulgaria",
        settlementHelper: "Settlement free text",
        coordsFromAddress: "Coordinates from address"
    },
    accommodation: {
        accommodationPlaces: "Accommodation places",
        name: "Name",
        nameEN: "English name",
        category: "Category",
        url: "URL",
        type: "Type",
        roomPrice: "Room Price",
        title: "Accommodation places",
        single: "Single",
        double: "Double",
        triple: "Triple",
        apartment: "Apartment",
        food: "Food",
        menu: "Menu",
        other1: "Other 1",
        other2: "Other 2"
    },
    project: {
        title: "Projects",
        information: "Information",
        number: "Project number",
        contract: "Contract",
        name: "Name",
        funding: "Financing",
        partners: "Partners",
        partner: "Partner",
        partnerContract: "Partner contract",
        addPartner: "Add partner",
        activity: "Activity / Direction",
        activities: "Activities / Directions",
        addActivity: "Add Activity / Direction",
        projectActivities: "Project activities",
        projectActivity: "Project activity"
    },
    externalSupplier: {
        title: "Contracts",
        company: "Supplier data",
        contactPersons: "Contact persons",
        contracts: "Contracts",
        id: "Id",
        status: "Active",
        addContactPerson: "Contact",
        addContract: "Contract",
        egnManager: "UCN - Manager",
        tariffs: "Tariffs",
        tariff: "Tariff",
        active: "Active",
        contractData: "Contract data",
        tariffName: "Name",
        isCompany: "Legal entity",
        historyRecordsGridHeader: {
            id: "Id",
            companyName: "Name of legal entity",
            deactivated: "Deactivated",
            other1: "Other 1",
            other2: "Other 2",
            deleted: "Deleted",
            personFullName: "Person name",
            isCompany: "Legal entity",
            externalSupplierSysStartTimeUtc: "System validity from",
            externalSupplierSysEndTimeUtc: "System validity to"
        }
    },
    publicOrder: {
        title: "Public orders",
        currentNumberPublicOrders:
            "Public order current number in Public orders register of Agency of Public orders",
        currentNumberNIP:
            "Public order current number in NIP's Public order register",
        itemName: "Public order item name",
        addFile: "Add Document",
        typeOfOrderType: "Assessment type",
        orderType: "Type of PPA activity",
        documents: "Documents",
        status: "Status",
        publishDate: "Publish date",
        description: "Description",
        termDate: "Term date",
        objectType: "Object type",
        referenceValue: "Reference value",
        referenceValueCurrency: "Currency",
        fileNumber: "Correspondence number",
        documentType: "Document type",
        documentInfo: "Document information",
        documentDate: "Buyer's profile attached file date",
        assignor: "Assignor",
        addContact: "Contact Person",
        contactPerson: "Contact People",
        referenceOrder: "Reference order",
        activity: "Activity",
        archive: "Archive",
        manualDocsType: "Instruction, documentation, model",
        infoDocsType: "Announcement, message, information, invitation, others",
        contractDocsType: "Contract, addendum",
        statementDocsType: "APO opinion",
        statusFrom: "From",
        statusTo: "To",
        statusUpdateDate: "Date",
        statusUpdatedBy: "Changed by",
        statusHistory: "Status history",
        historyRecordsGridHeader: {
            id: "Id",
            nipCurrentNumber: "NIJ current number",
            subject: "Subject",
            publishDateUtc: "Publishing date",
            statusName: "Status",
            typeName: "Type",
            assignmentTypeName: "Assignment type",
            other1: "Other 1",
            other2: "Other 2",
            contactPersonId: "Contact person №",
            description: "Description",
            termDate: "Term date",
            objectTypeName: "Object type name",
            referenceValue: "Reference value",
            referenceValueCurrencyName: "Reference value currency",
            isOpen: "Open",
            publicOrdersCurrentNumber: "public order current number",
            referenceOrderId: "Reference order №",
            activityId: "Activity №",
            deleted: "Deleted",
            sysStartTimeUtc: "System start time",
            sysEndTimeUtc: "System end time",
            createdAtUtc: "Created at",
            creatorUsername: "Created by",
            updatedAtUtc: "Updated at",
            updaterUsername: "Updated by",
            publicOrderSysStartTimeUtc: "System start time of public order",
            publicOrderSysEndTimeUtc: "System end time of public order"
        }
    },
    thematicArea: {
        id: "Id",
        title: "Thematic areas",
        information: "Information",
        name: "Name",
        legalArea: "Legal Area",
        lector: "Lecturer",
        lectors: "Lecturers",
        event: "Event",
        events: "Events",
        theme: "Theme",
        thematicArea: "Thematic area",
        thematicAreaProposal: "Proposal for thematic area",
        saveProposal: "Save proposal"
    },
    institution: {
        title: "Institutions and organizations",
        information: "Information",
        mainInfo: "Main information",
        id: "Id",
        type: "Organization type",
        level: "Organization level",
        appellateRegion: "Appellate region(BG)",
        appellateRegionEn: "Appellate region",
        name: "Organization/Institution name(BG)",
        nameEn: "Organization/Institution name",
        protocol: "Protocol",
        realMagistratesCount: "Real magistrates count",
        realEmployeesCount: "Real employees count",
        formalMagistratesCount: "Formal magistrates count",
        formalEmployeesCount: "Formal employees count",
        totalFormalCount: "Total formal count",
        stateGazette: "State Gazette",
        vatNumberExistsCheck: "Check the use of the VAT number",
        vatNumberExists: "The VAT number '{0}' is already used in an institution '{1}' with id {2}!"
    },
    activity: {
        title: "Activities / Directions",
        information: "Information",
        name: "Activity/Direction name",
        type: "Type",
        id: "Id",
        subType: "subtype",
        subActivity: "Sub-activity",
        direction: "Direction",
        subDirection: "Sub-direction",
        activity: "Activity",
        details: "Details"
    },
    administrativePosition: {
        id: "Id",
        title: "NIJ Administrative positions",
        substitutions: "Substitutions",
        name: "Position",
        department: "Department",
        directorate: "Directorate",
        contactDetails: "Contact details",
        location: "Location",
        information: "Information",
        addSubstitution: "Add",
        allEmployeesChange: "Changes for all employees",
        managerPosition: 'Manager'
    },
    searchDropdown: {
        noResults: "No results found",
        minSearchChars: "Enter at least {searchMinLength} symbols to search..."
    },
    foreignLanguage: {
        language: "Language",
        fluencyLevelByEEP: "Fluency level by EEP",
        fluencyLevelBySelfAssessment: "Fluency level by self-assessment",
        addForeignLanguage: "Add foreign language"
    },
    organizerActivity: {
        cardTitle: "Activity / History",
        name: "Name",
        date: "Date",
        description: "Descrption",
        eventType: "Event",
        partnershipForm: "Partnership form",
        finParticipationType: "Financial contribution type"
    },
    company: {
        title: "@:sideMenu.company",
        id: "Id",
        cardTitle: "Company info",
        name: "Name",
        vatNumber: "VAT Number",
        bulstatUic: "Bulstat UIC",
        phone: "Phone",
        fax: "Fax",
        url: "Web site",
        description: "Description",
        manager: "Manager",
        contact: "Contact person",
        registeredAddress: "Registration address",
        contactAddress: "Correspondence address",
        bankAccount: "Bank account",
        createdAt: "Date of creation",
        updatedAt: "Last date of update",
        createdBy: "Created by",
        updatedBy: "Updated by",
        email: "Email",
        edit: "Compan edit"
    },
    contract: {
        cardTitle: "Contract / Agreement",
        number: "Number",
        amount: "Amount",
        name: "Name",
        subject: "Subject",
        validFrom: "Valid from",
        validTo: "Valid to",
        conclusionDate: "Conclusion date",
        description: "Description",
        externalSupplier: "External supplier"
    },
    bankAccount: {
        cardTitle: "Bank account",
        bankName: "Bank",
        bic: "BIC",
        iban: "IBAN",
        description: "Description"
    },
    account: {
        title: "Acount",
        logs: "Action logs",
        auditlogs: "Audit logs",
        audit: {
            gridHeaders: {
                id: "Id",
                userName: "User",
                actionName: "Action",
                controllerName: "Controller",
                activity: "Status",
                ipAddress: "IP address",
                duration: "Duration ms",
                timeAccessed: "Time",
                timeAccessedUtc: "Time UTC",
                formatedTimeUtc: "Time UTC",
                requestMethod: "Request type",
                urlAccessed: "Url",
                sessionId: "Session Id",
                auditTypeStr: "Audit type",
                hash: "Security hash",
                data: "Data",
                additionalData: "Additional data"
            }
        },
        log: {
            gridHeaders: {
                id: "Id",
                auditId: "Audit log id",
                userName: "User",
                description: "Action",
                time: "Time"
            }
        }
    },
    audit: {
        validation: "Validation",
        chainValidation: "Chain validation"
    },
    kendoGrid: {
        columnsVisibility: "Columns visibility",
        userSettings: "User settings",
        excelExportSettings: "Excel export settings",
        pdfExportSettings: "Pdf export settings",
        options: {
            columnMenu: "Show menu in column header",
            reorderable: "Allow column rearrange",
            resizable: "Allow column resize",
            groupable: "Allow column group",
            filterable: "Allow filtering",
            sortable: "Allow sorting",
            fileName: "File name",
            allPages: "Export all the pages",
            collapsible: "Collapsible",
            avoidLinks: "Avoid links",
            paperSize: "Paper size",
            margin: "Margin",
            landscape: "Landscape orientation",
            repeatHeaders: "Repeat headers to all pages",
            scale: "Scale",
            rowsPerPage: "Rows count per page",
            scrollable: "Allow scrolling",
            selectable: "Items copy mode",
            navigatable: "Navigate by rows",
            showColumnValueFullText: "Show all the text in the fields"
        },
        grouping: {
            emptyText:
                "Drag a column header and drop it here to group by that column"
        },
        loading: "Grid loading",
        pagerMessages: {
            display: "{0} - {1} of {2} items",
            empty: "No items to display",
            page: "Page",
            allPages: "All",
            of: "of {0}",
            itemsPerPage: "items per page",
            first: "Go to the first page",
            previous: "Go to the previous page",
            next: "Go to the next page",
            last: "Go to the last page",
            refresh: "Refresh"
        }
    },
    request: {
        response: {
            status: {
                200: "OK",
                240: "Warning",
                400: "Bad request",
                403: "Forbidden",
                404: "Not found",
                405: "Method Not Allowed",
                500: "Server error",
                999: "Грешка"
            }
        }
    },
    registers: {
        lectors: {
            id: "Id",
            teachingData: "Area of competence",
            thematicArea: "Thematic area",
            themes: "Tehemes",
            lectorsTeaching: "Teaching teachers",
            universityTeaching: "Teaching in university",
            nipTeaching: "Teaching in National institute of justice",
            practitionersTeaching: "Teaching practitionaers",
            status: "Status",
            notes: "Notes",
            reasonForJoiningLikeLector:
                "Reason for inclusion in the Electronic Register",
            reasonForJoining: "Basis for inclusion",
            decision: "Management board decision",
            decisionDate: "Decision date",
            additionalInfo: "Additional information",
            reasonForReleaseLikeTeacher: "Basis for release as a teacher",
            reasonForRelease: "Basis for release",
            cv: "CV",
            attachedDocuments: "Attached documents",
            title: "Title",
            salutation: "Salutation",
            identityCard: "Identity card №",
            identityCardCreatedOn: "Created on",
            identityCardCreatedTown: "Created in",
            livingAddress: "Address by Id",
            institution: "Institution",
            workPlace: "Workplace",
            contractData: "Contract data",
            eventsParticipation: 'Events participation as lecturer'
        },
        editor: {
            title: "Editor"
        },
        organizers: {
            title: "Organizers / Partners",
            gridHeaders: {
                id: "Id",
                name: "Name",
                description: "Description",
                companyName: "Company name",
                registeredAddress: "Address of registration",
                phone: "Phone",
                managerName: "Manager name",
                contactName: "Contact name",
                active: "Active"
            }
        },
        accommodation: {
            title: "Accommodation places register",
            menuTitle: "Accommodation places"
        },
        fieldTypes: {
            title: "Dynamic registers field types",
            gridHeaders: {
                id: "Id",
                type: "Type",
                name: "Name",
                nameEn: "Name En",
                deactivated: "Deactivated",
                active: "Active"
            }
        },
        publicOrder: {
            title: "Public orders",
            menuTitle: "Public orders",
            archiveTitle: "Archive",
            activeTitle: "Active",
            plannedTitle: "Planned"
        },
        registerTypes: {
            title: "Dynamic registers types",
            gridHeaders: {
                id: "Id",
                name: "Name",
                nameEn: "Name En",
                deactivated: "Deactivated",
                active: "Active"
            }
        },
        staticRegistersForDropdown: {
            title:
                "Static register used as a source for dropdown component, used when creating a dynamic register",
            gridHeaders: {
                id: "Id",
                staticRegisterName: "Register name",
                displayMember: "Column name used as a display member",
                description: "Description",
                deactivated: "Deactivated",
                active: "Active",
                allowAnonymousAccesss: "Anonymous access"
            }
        },
        nomenclatures: {
            title: "Nomenclatures",
            add: "Add nomenclature",
            parentInfo: "Parent info",
            foreignCities: 'Foreign cities',
            gridHeaders: {
                id: "Id",
                parentId: "Parent Id",
                parentName: "Parent name",
                parentNameEn: "Parent name En",
                name: "Name",
                nameEn: "Name En",
                sort: "Sort number",
                description: "Description",
                deactivated: "Deactivated",
                active: "Active",
                deleted: "Deleted",
                color: "Color"
            },
            editor: {
                editActive:
                    "Edit field '@:registers.nomenclatures.editor.active'",
                active: "Active"
            },
            confirmations: {
                create:
                    "Are you sure you want to create a nomenclature with a name: ",
                edit:
                    "Are you sure you want to edit a nomenclature with a name: "
            },
            warnings: {
                emptySelection: "Selected nomenclatures are missing."
            }
        },
        dynamic: {
            title: "Dynamic registers",
            gridHeaders: {
                id: "Id",
                name: "Name",
                nameEn: "Name En",
                deactivated: "Deactivated",
                active: "Active",
                locked: "Locked for edition"
            }
        },
        participants: {
            title: "Participants",
            freeSeats: "Free seats",
            details: "Participant details",
            edit: "Editing of a participant",
            updatePersonFromParticipant: "Editing related Person date",
            updatePersonFromParticipantDescription:
                "Determines whether or not the related Person data is updated during editing",
            gridHeaders: {
                participant: "Participant"
            },
            help: {
                participantsGridInfo:
                    'Entries whose "Participation Type" is marked as "Participant" ("Student") are displayed.',
                allAppearanceGridInfo:
                    'All records, regardless of their "Participation Type", are displayed'
            },
            emptySelection: "Selected participants are missing",
            multipleEditTitle: "Editing of a participants"
        },
        events: {
            title: "Events",
            eventsOutOfCatalog: 'Events outside of annual catalog',
            eventsInCatalog: 'Events by annual catalog',
            eventForms: "Event forms",
            lockedForEdit: "The event is locked for editing",
            lecturers: {
                title: "Lecturers",
                noLecturers: "No lecturers added to this event."
            },
            help: {
                eventStartDate:
                    "Event start date and time. See the General Data section, the Basic Data panel.",
                eventEndDate:
                    "Event end date and time. See the General Data section, the Basic Data panel.",
                eventSubscriptionStartDate:
                    "See the General Data section, the Application / Save Button panel.",
                eventSubscriptionEndDate:
                    "See the General Data section, the Application / Save Button panel."
            },
            errors: {
                outOfEventDateRange:
                    "Outside the time of the event itself. See the General Data section, the Basic Data panel.",
                outOfEventSubscriptionDateRange:
                    "Beyond application / enrollment time. See the General Data section, the Application / Save Button panel."
            },
            warnings: {
                eventHasChanged: 'There are changes. Please save the event.'
            },
            gridHeaders: {
                id: "Id",
                name: "Name",
                eventCode: "Event`s ID ",
                eventStartDate: "Start",
                eventEndDate: "End",
                eventSubscriptionStartDate: "Enrollment start",
                eventSubscriptionEndDate: "Enrollment end",
                eventDailyAllowanceFrom: "Daily allowance from",
                eventDailyAllowanceTo: "Daily allowance to",
                eventStayFrom: "Stay from",
                eventStayTo: "Stay to",
                statusName: "Status",
                eventForm: "Event format",
                eventType: "Type of event",
                eventVenue: "Event venue",
                eventProjectName: "Project name",
                eventOrganizerName: "Organizer / Partner",
                participantsMaxNum: "Max number of students",
                eventLocation: "Location",
                eventActivityDirection: "Direction",
                eventLegalArea: "Juridical area",
                eventFundingType: "Financing",
                eventNote: "Note",
                eventDirectorate: "Directorate",
                eventAudience: "Audience",
                thematicArea: "Thematic area",
                theme: "Theme",
                institutionOfEmployment: "Institution",
                eventSort: "Event sort",
                eventMoodleCategory: "Moodle category",
                eventDescription: "Description",
                eventExpectedResults: "Expected results",
                eventLearningGoals: "Learning goals",
                useExtSubscriptionService: "External service of enrollment",
                extSubscriptionService: "External service link",
                eventMigrationId: "Migration Id",
                eventId: 'Event Id',
                moduleName: 'Module name',
                isMainEventModule: 'Main module',
                certificateDate: 'Certified on',
                moodleId: 'Moodle Id',
                moodleResults: 'Moodle certificates',
                eventLabel: "Labels",
            },
            statuses: {
                active: "Active",
                past: "Past",
                upcoming: "Upcoming",
                activeEnrollment: "Active enrollment",
                pastEnrollment: "Past enrollment",
                upcomingEnrollment: "Upcoming enrollment",
                deleted: "Deleted",
                deactivated: "Deactivated"
            },
            tooltip: {
                name: "Event name",
                coords: "Coordinates",
                link: "Link to the event"
            },
            generalData: {
                title: "General data",
                participantsMaxNum: "Maximum number of students",
                excludeFromReporting: "Exclude from reporting",
                syncedWithMoodle: "Synced with Moodle",
                moodleSyncResult: "Moodle sync details",
                eventLink: "Link to the event",
                public: "Public",
                lockedForEdit: "Locked in for editing",
                syncWithMoodleForPrivateEventBan:
                    "Syncing a non-public event with Moodle is not allowed!"
            },
            evaluation: {
                criteria: {
                    title: "Ranking criteria",
                    useTemplate: "Use a template",
                    gridHeaders: {
                        id: "Id",
                        code: "Code",
                        name: "Name",
                        nameEn: "Name En",
                        note: "Note"
                    },
                    score: "Rating points",
                    value: "Valuation value",
                    errors: {
                        invalidScore: "Invalid rating points",
                        invalidValue: "Invalid value",
                        invalidOperator: "Invalid operator",
                        invalidProperty: "Invalid property"
                    },
                    add: "Adding ranking criteria",
                    saveAsTemplate: "Save as template",
                    additionallyAdded: "Additionally added",
                    date: "Date",
                    year: "Year",
                    type: "Type",
                    operator: "Operator",
                    property: "Property"
                },
                participationRequests: {
                    title: "Applications for participation"
                },
                accommodationRequests: {
                    title: "Applications for accommodation"
                },
                tempRanking: {
                    title: "Temp ranking",
                    admitted: "Admitted",
                    rejected: "Rejected",
                    reserve: "Reserve",
                    active: "Active",
                    version: "Version",
                    confirmMaxDate: "Confirmation end date",
                    eventName: "Event name",
                    eventStartDate: "Event start date",
                    eventEndDate: "Event end date",
                    eventDetails: "Event details",
                    statistica: "Statistics",
                    new: "New",
                    addCandidate: "Add candidate",
                    createNewConfirmation:
                        "Are you sure you want to create a new temp ranking? The data of the existing one will be deleted.",
                    moveToAdmitted:
                        "Are you sure you want to move id to the Admitted section?",
                    moveToRejected:
                        "Are you sure you want to move id to the Rejected section?",
                    moveToReserve:
                        "Are you sure you want to move id to the Reserve section?",
                    confirmConfirmation:
                        "Are you sure you want to confirm participation? If a rejection is available, it will be deleted!",
                    confirmRejection:
                        "Are you sure you want to reject participation? If participation confirmation is available, it will be deleted! Please provide a reason.",
                    pendingConfirmation: "Pending confirmation",
                    pendingConfirmationDetails:
                        "Participations in temp rankings that require confirmation",
                    isConfirmed: "Confirmed",
                    isConfirmRejected: "Confirmation rejected",
                    isManuallyAdded: "Manually added",
                    isNotifiedByPhone: "Notified by phone",
                    dateOfNotificationUtc: "Date of notification",
                    phoneOfNotification: "Phone of notification",
                    isParticipant: "Participant",
                    confirmed: "Confirmed participations",
                    confirmedDetails:
                        "Confirmed participations in temp rankings that require confirmation",
                    confirmation: {
                        gridHeaders: {
                            time: "Confirmation time",
                            username: "Username"
                        },
                        create: "Are you sure you want to manually add a candidate",
                        update: "Are you sure you want to edit a candidate",
                        delete: "Are you sure you want to delete a candidat",
                        confirmationDelete: "Are you sure you want to delete the confirmation of the candidate",
                        syncWithFormEntityData: "Are you sure you want to update '{name}' using the information on the participation request form?",
                        syncAllWithFormEntityData: "Are you sure you want to update the candidates in the provisional ranking using the data from the entry form?"
                    },
                    notCreated: "No temporary ranking created.",
                    applyCofirmation:
                        "Are you sure you want to transfer the admitted temporary participants to participants? Only confirmed participants will be transferred!",
                    applySingleCofirmation:
                        "Are you sure you want to transfer the selected eligible participant as an actual participant?",
                    activeButtonInfo:
                        "Enabling or disabling temporary rankings determines the ability of users to confirm entries, as well as the ability to apply the rankings and enroll actual participants.",
                    activeButtonInfo1:
                        'When you create a new provisional ranking, requests are analyzed using "Request for Entry" forms, all of which have been completed. For information: the Forms Included card in the "Manage Forms" section.',
                    activeButtonInfo2:
                        "When the ISUPO is set up to allow the creation of a provisional ranking without having established eligibility and evaluation criteria, a ranking will be made according to the provisional creation of the application for participation.",
                    applyButtonInfo:
                        'The application of a provisional ranking will record eligible and verified users as actual participants, with an "accepted and confirmed participation" participation update.',
                    applyButtonInfo1:
                        'Anyone who has accepted and confirmed participation can be transferred as a real participant, with an entry for participation "Approved and confirmed participation". This is possible by managing every entry in the Allowed grid',
                    accommodationRequestRequired:
                        "Accommodation request required",
                    accommodationRequestRequiredHelp:
                        "I will request the completion of accommodation confirmation information.",
                    activeButtonInfo3:
                        "In order for the confirmation to be active, it is necessary to have admitted participants, the event to be public and upcoming (without a set start date or a future start date). The participant confirming the participation must have the right to fill in forms and questionnaires (FormSurveyEntity => Create).",
                    editor: {
                        create: "Add a candidate",
                        update: "Candidate update"
                    },
                    history: {
                        title: 'Temp ranking history',
                        candidates: 'Candidates for participation'
                    },
                    notifiedSelectedAdmitted: "Are you sure you want to notify selected participants?",
                }
            },
            notSaved: "The event was not saved",
            participants: {
                title: "Participants",
                gridHeaders: {
                    id: "Id",
                    titleDegree: "Title / Degree",
                    name: "Name",
                    nameTransliterated: "Name (En)",
                    identificationType: "Identification type",
                    identificationNumber: "Identification №",
                    position: "@:person.position",
                    positionStatistic: "@:person.positionStatistic",
                    positionFullName: "@:person.positionFullName",
                    educationDegree: "Education",
                    institutionNomenclature: "Institution",
                    institutionCity: "City",
                    institutionMigrationName: "Inst. migration data",
                    createdAt: "Date of creation",
                    updatedAt: "Last date of update",
                    createdBy: "Created by",
                    updatedBy: "Updated by",
                    management: "Management",
                    relationType: "Ground for participation",
                    participationType: "Participation type",
                    status: "Participation status",
                    reasonForAdmission: "Reason for admission / non-admission",
                    note: "Note",
                    eventName: "Event",
                    eventStartDate: "Event start date",
                    eventEndDate: "Event end date",
                    syncWithMoodle: "Synced",
                    isFromTempRanking: "Temp rank",
                    email: "Email",
                    rank: "Rank",
                    score: "Score",
                    hasCertificate: "Certificate issued",
                    moduleName: '@:registers.events.gridHeaders.moduleName',
                    isMainEventModule: '@:registers.events.gridHeaders.isMainEventModule',
                    certificateDate: 'Released on',
                    moodleId: 'Moodle Id',
                    moodleResults: 'Certificates issued by Moodle',
                    notified: 'Notified',
                    notificationDate: 'Notification date',
                    rejectionNote: 'Reason'
                },
                confirmations: {
                    delete: "Are you sure you want do delete participant",
                    import:
                        "Are you sure you want to import participant from a excel file?",
                    certificateIssed:
                        "A certificate has already been issued. Are you sure you want to issue a new one? The old one will be deleted.",
                        notifiedSelected: "The event has passed or started! Are you sure you want to notify selected participants?",
                },
                help: {
                    participationType: "Determines the role of participation.",
                    relationType: "Determines the ground for participation",
                    participationStatus:
                        'Link to nomenclature "Participation status".',
                    reasonForAdmission: ""
                },
                editor: {
                    editParticipationType: "Edit field '@:registers.events.participants.gridHeaders.participationType'",
                    editRelationType: "Edit field '@:registers.events.participants.gridHeaders.relationType'",
                    editReasonForAdmission: "Edit field '@:registers.events.participants.gridHeaders.reasonForAdmission'",
                    editStatus: "Edit field '@:registers.events.participants.gridHeaders.status'",
                    editNote: "Edit field '@:registers.events.participants.gridHeaders.note'",
                    editPosition: "Edit field '@:registers.events.participants.gridHeaders.position'",
                    editPositionStatistic: "Edit field '@:registers.events.participants.gridHeaders.positionStatistic'",
                    editEducationDegree: "Edit field '@:registers.events.participants.gridHeaders.educationDegree'",
                    editInstitutionRegister: "Edit field '@:registers.events.participants.gridHeaders.institutionNomenclature'"
                },
            },
            budget: {
                title: "Budget"
            },
            costs: {
                title: "Costs"
            },
            budgetReport: {
                title: "Report"
            },
            subscriptions: {
                title: "Subscribed users"
            },
            confirmations: {
                delete: "Are you sure you want to delete an event",
                unDelete: "Are you sure you want to undelete an event",
                archive: "Are you sure you want to archive an event",
                unarchive: "Are you sure you want to uncheck 'archived' event"
            },
            organizationalDocs: "Organizational documents",
            eventClaims: "Claims"
        },
        lecturers: {
            title: "Lecturers",
            gridHeaders: {},
            confirmations: {
                delete: "Are you sure you want do delete lecturer"
            },
            multipleEditTitle: "Editing of lecturers",
            emptySelection: "Selected lecturers are missing"
        },
        employees: {
            title: "NIJ Employees",
            onlyWithValidUsers: "Only with valid users",
            gridHeaders: {
                manager: "Manager",
                directorate: "Directorate",
                workPhone: "Work Number",
                workPlace: "Work Place",
                workPlaceAddress: "Work place address",
                workData: "Work Data",
                positionNij: 'NIJ position',
                userName: "@:userName",
                activeUser: 'Active user',
                isLeft: 'Left',
                leavingDate: 'Leaving date',
                deleted: 'Deleted'
            },
            activityЕvaluation: "Activity evaluation",
            year: "Year",
            evaluation: "Evaluation",
            organogram: "Orthogram",
            organogramTitle: "NIJ employees orthogram"
        },
        mentors: {
            title: "Mentors",
            gridHeaders: {
                id: "Id",
                directorate: "Directorate",
                salutation: "Salutation",
                workPlace: "Workplace",
                institution: "Institution",
                startDate: "Start date",
                endDate: "End date",
                additionalInfo: "Additional information",
                decision: "Decision",
                reasonForJoiningLikeMentor: "Reason for joining as mentor",
                addParticipant: "Add participant"
            }
        },
        forms: {
            title: "Forms",
            management: "Forms management",
            includedForms: "Included forms",
            templates: "Templates",
            templatesCopies: "Copies of templates for the given event",
            active: "Active",
            activeForms: "Active forms",
            my: "My forms",
            completed: "Completed forms",
            subscriptionMinDateDescription: "",
            subscriptionMaxDateDescription: "",
            choose: "Choose form",
            eventsWithParticipationOnly:
                "Forms for events in which I participate",
            completionRightsWarning: "The form/Survey is limited to completion and editing.",
            gridHeaders: {
                id: "Id",
                registerEntityId: "Event Id",
                eventName: "Event",
                eventStartDate: "Event start",
                eventEndDate: "Event end",
                participationStatus: "Participation status",
                name: "Name",
                nameEn: "Name En",
                formType: "Type",
                formTypeEn: "Type En",
                validFromUtc: "Valid from UTC",
                validToUtc: "Valid to UTC",
                note: "Note",
                isTemplate: "Template",
                isCompleted: "Completed",
                deactivated: "Deactivated template",
                formToEventDeactivated: "Deliberately activated for completion",
                deleted: "Deleted",
                status: "Status",
                allRecords: "Records",
                validRecords: "Valid records",
                deletedRecords: "Deleted records",
                deactivatedRecords: "Deactivated records",
                creatorUsername: "Created by",
                createdAtUtc: "Created at",
                updaterUsername: "Updated by",
                updatedAtUtc: "Updated at",
                management: "Management",
                canEdit: "Can edit",
                position: "Position",
                formName: "Form / Questionnaire name",
                creator: "Creator",
                participationType: "Participation type",
                isPopulatingRequired: 'Is populating required',
                isAnonymous: "Anonymous Form / Questionnaire name",
                isAuthorHidden: "Hidden author",
                isFingerprintingDisabled: "Fingerprinting disabled",
            },
            editor: {
                name: "Name",
                nameEn: "Name (En)",
                useAsTemplate: "Use as a template",
                formType: "Type",
                relatedEvent: "Related event",
                validFrom: "Valid from",
                validTo: "Valid to",
                deactivate: "Deactivate",
                note: "Note",
                header: "Header",
                footer: "Footer",
                helps: {
                    relatedEvent:
                        "The form will join the selected event (Form Management section), which determines its activity.",
                    participationType: "Determines the role of participation.",
                    participationType1: "When adding a participation request form, the field should be blank.",
                }
            },
            formToEvent: {
                title: "Forms / questionnaires",
                gridHeaders: {
                    name: "Name",
                    nameEn: "Name En",
                    formType: "Type",
                    formTypeEn: "Type En",
                    validFromUtc: "Valid from",
                    validToUtc: "Valid to",
                    note: "Note",
                    active: "Active",
                    comletionLink: "Link to fill out a form",
                    participationTypes: "Related participation type"
                },
                create: "Include a form to an event",
                edit: "Edit an included form for an event",
                help: {
                    isTemplateToNameHelp:
                        "The form is marked as a template and its name cannot be edited.",
                    formName:
                        "The value of the '@:registers.forms.gridHeaders.formName' must be unique."
                },
                warnings: {
                    useUniqueFormName:
                        "Please use unique '@:registers.forms.gridHeaders.formName'."
                }
            },
            confirmations: {
                save: "Are you sure you want to save the related forms?",
                addToForm:
                    "Are you sure you want to add the selected form to the event?",
                deleteLinkedForm:
                    "Are you sure you want to delete the event-form link?",
                edit: "Are you sure you want to edit the selected form?",
                deleteFormWithRelatedRecords: "Are you sure you want to delete the form, including completed forms?",
                deleteLinkedFormWithForm:
                    "Are you sure you want to delete the event-form link, including the form itself?"
            },
            help: {
                add:
                    "Form templates are available for adding, which are tagged as templates."
            }
        },
        theme: {
            title: "Event theme",
            gridHeaders: {
                id: "Id",
                thematicArea: "Thematic area",
                legalArea: "Legal area",
                name: "Name",
                nameEn: "Name En",
                deactivated: "Deactivated",
                active: "Active",
                sort: "Sort number"
            }
        },
        electronicLecturers: {
            title: "An electronic register of professors from the judiciary",
            gridHeaders: {
                id: "Id",
                fullName: "Full name",
                titleDegree: "Title / Degree",
                firstName: "Name",
                middleName: "Middle name",
                lastName: "Last name",
                positionStatistic: "Professional category",
                position: "Position",
                institutionCompanyName: "Institution",
                institutionCompanyCountry: "Country",
                institutionCompanyCity: "City",
                thematicAreas: "Thematic area",
                themes: "Theme",
                lectorsTeaching: "Teaching of trainers",
                universityTeaching: "Teaching in NIJ",
                nipTeaching: "Teaching in university",
                practitionersTeaching: "Teaching legal practitioners",
                reasonForJoining: "Ground for inclusion",
                decisionForJoining: "Decision of the Management",
                decisionForJoiningDate: "Date of decision",
                reasonForRelease: "Ground for dropping out",
                decisionForRelease: "Reason for dropping out",
                decisionForReleaseDate: "Date of decision"
            }
        }
    },
    buttons: {
		saveAdnAddNew: 'Save and add new',
        ok: "Ok",
        cancel: "Cancel",
        close: "Close",
        open: "Open",
        unlockForEdit: 'Unlock for edit',
        edit: {
            btnText: "Edit",
            tooltipText: "Edit",
            action: "Editing"
        },
        editInNewTab: {
            btnText: "Edit in new tab",
            tooltipText: "Edit in new tab"
        },
        editSelected: {
            btnText: "Edit selected",
            tooltipText: "Edit selected"
        },
        deactivate: {
            btnText: "Deactivate",
            tooltipText: "Deactivate",
            action: "Deactivate",
            already: "Already deactivated!",
            status: "Deactivated",
            confirmationText: "Are you sure you want to deactivate \"{name}\" ?"
        },
        activate: {
            btnText: "Activate",
            tooltipText: "Activate",
            action: "Activate",
            already: "Already activated!",
            status: "Activated",
            confirmationText: "Are you sure you want to activate \"{name}\" ?"
        },
        create: {
            btnText: "New",
            btnText_a: "New",
            tooltipText: "New",
            tooltipEvent: "Create event",
            action: "Creation"
        },
        exportTemplate: {
            btnText: "Export template",
            tooltipText: "Export Excel template"
        },
        importFromExcel: {
            btnText: "Import from Excel",
            tooltipText: "Import data from Excel"
        },
        delete: {
            btnText: "Delete",
            tooltipText: "Delete",
            action: "Delete",
            already: "Already deleted!",
            confirmationText: "Are you sure you want to delete?",
            confirmationText1: "Are you sure you want to delete \"{name}\" ?"
        },
        undelete: {
            btnText: "Marked as undeleted",
            tooltipText: "Marked as undeleted",
            confirmationText: "Are you sure you want to mark as undeleted?",
            confirmationText1: "Are you sure you want to mark as undeleted \"{name}\" ?",
        },
        details: {
            btnText: "Details",
            tooltipText: "Details",
            action: "Details"
        },
        detailsAll: {
            btnText: "Details of all",
            tooltipText: "Details of all",
            action: "Details of all"
        },
        detailsShowInDescription: {
            btnText: "Details of those marked for display",
            tooltipText: "Details of those marked for display",
            action: "Details of those marked for display"
        },
        detailsActive: {
            btnText: "Details of the active",
            tooltipText: "Details of the active",
            action: "Details of the active"
        },
        detailsInNewTab: {
            btnText: "Details in new tab",
            tooltipText: "Details in new tab",
            action: "Details in new tab"
        },
        accountDetailsInNewTab: {
            btnText: "Account details in new tab",
            tooltipText: "Account details in new tab",
            action: "Account details in new tab"
        },
        pinToDashboard: {
            btnText: "Pin to home page",
            tooltipText: "Pin to home page"
        },
        unpinFromDashboard: {
            btnText: "Unpin from home page",
            tooltipText: "Unpin from home page"
        },
        minimize: {
            btnText: "Minimize",
            tooltipText: "Minimize"
        },
        maximize: {
            btnText: "Maximize",
            tooltipText: "Maximize"
        },
        hide: {
            btnText: "Hide",
            tooltipText: "Hide"
        },
        userSettings: {
            btnText: "User settings",
            tooltipText: "User settings"
        },
        settings: {
            btnText: "Settings",
            tooltipText: "Settings"
        },
        pdfExport: {
            btnText: "Pdf",
            tooltipText: "Export to Pdf"
        },
        excelExport: {
            btnText: "Excel",
            tooltipText: "Export to Excel"
        },
        saveGridOptions: {
            btnText: "Save grid settings",
            tooltipText: "Save grid settings"
        },
        loadGridOptions: {
            btnText: "Load grid settings",
            tooltipText: "Load grid settings"
        },
        delteGridOptions: {
            btnText: "Delete grid settings",
            tooltipText: "Delete grid settings"
        },
        submit: {
            btnText: "Submit",
            tooltipText: "Submit"
        },
        clearFilters: {
            btnText: "Clear filters",
            tooltipText: "Clear filters"
        },
        filter: {
            btnText: "Filter",
            tooltipText: "Filter"
        },
        search: {
            btnText: "Search",
            tooltipText: "Search"
        },
        save: {
            btnText: "Save",
            tooltipText: "Save",
            confirmationText: "Are you sure you want to save?"
        },
        complete: {
            btnText: "Fill in",
            tooltipText: "Fill in"
        },
        load: {
            btnText: "Loading",
            tooltipText: "Loading"
        },
        doLoad: {
            btnText: "Load",
            tooltipText: "Load"
        },
        add: {
            btnText: "Add",
            tooltipText: "Add",
            action: "Add"
        },
        archive: {
            btnText: "Archive",
            tooltipText: "Archive"
        },
        unarchive: {
            btnText: "Unarchive",
            tooltipText: "Unarchive"
        },
        history: {
            btnText: "History",
            tooltipText: "History"
        },
        clear: {
            btnText: "Clear",
            tooltipText: "Clear"
        },
        syncWithMoodle: {
            btnText: "Sync with Moodle",
            tooltipText: "Sync with Moodle"
        },
        createUserAccountInMoodle: {
            btnText: "Create user account in moodle",
            tooltipText: "Create user account in moodle"
        },
        reject: {
            btnText: "Reject",
            tooltipText: "Reject"
        },
        reserve: {
            btnText: "Reserve",
            tooltipText: "Reserve"
        },
        admit: {
            btnText: "Admit",
            tooltipText: "Admit"
        },
        confirm: {
            btnText: "Confirm",
            tooltipText: "Confirm"
        },
        confirmationDelete: {
            btnText: "Delete confirmation",
            tooltipText: "Delete confirmation"
        },
        reload: {
            btnText: "Reload",
            tooltipText: "Reload"
        },
        apply: {
            btnText: "Apply",
            tooltipText: "Apply",
            action: "Apply"
        },
        loadUserSettings: {
            btnText: "Load user settings",
            tooltipText: "Load user settings"
        },
        copy: {
            btnText: "Copy",
            tooltipText: "Copy"
        },
        saveAsTemplate: {
            btnText: "Save as template",
            tooltipText: "Save as template"
        },
        taskDetails: {
            btnText: "Task",
            tooltipText: "Task",
            action: "Task"
        },
        roleManagement: {
            btnText: "Role management",
            tooltipText: "Role management",
            action: "Role management"
        },
        claimEdit: {
            btnText: "Claims edit",
            tooltipText: "Claims edit",
            action: "Claims edit"
        },
        roleEdit: {
            btnText: "Claims of user group edit",
            tooltipText: "Claims of user group edit",
            action: "Claims of user group edit"
        },
        management: {
            btnText: "Management",
            tooltipText: "Management",
            action: "Management"
        },
        participantsInGroupEdit: {
            btnText: "Participants in user group edit",
            tooltipText: "Participants in user group edit",
            action: "Participants in user group edit"
        },
        createAndLoad: {
            btnText: "Create and load",
            tooltipText: "Create and load",
            tooltipEvent: "Create and load"
        },
        personEdit: {
            btnText: "Person edit",
            tooltipText: "Person edit",
            tooltipEvent: "Person edit"
        },
        personDetails: {
            btnText: "Person details",
            tooltipText: "Person details",
            tooltipEvent: "Person details"
        },
        personSelect: {
            btnText: "Person select",
            tooltipText: "Person select",
            tooltipEvent: "Person select"
        },
        relatedRecords: {
            btnText: "Related records",
            tooltipText: "Related records",
            tooltipEvent: "Related records"
        },
        export: {
            btnText: "Export",
            tooltipText: "Export",
            tooltipEvent: "Export"
        },
        remove: {
            btnText: "Remove",
            tooltipText: "Remove",
            tooltipEvent: "Remove"
        },
        softDelete: {
            btnText: "Soft delete",
            tooltipText: "Soft delete",
            action: "Soft delete",
            confirmationText: "Are you sure you want to delete?",
            confirmationText1: "Are you sure you want to delete "
        },
        deleteWithPerson: {
            btnText: "Delete incl. person",
            tooltipText: "Delete incl. person",
            action: "Delete incl. person",
            confirmationText: "Are you sure you want to delete?",
            confirmationText1: "Are you sure you want to delete "
        },
        realDelete: {
            btnText: "Real delete",
            tooltipText: "Real delete",
            action: "Real delete",
            confirmationText: "Are you sure you want to delete?",
            confirmationText1: "Are you sure you want to delete "
        },
        viewEvent: {
            btnText: "View event",
            tooltipText: "View event",
            tooltipEvent: "View event"
        },
        newTask: {
            btnText: "New task",
            tooltipText: "New task",
            tooltipEvent: "New task"
        },
        newCertificate: {
            btnText: "New certificate",
            tooltipText: "New certificate",
            tooltipEvent: "New certificate"
        },
        editTemplate: {
            btnText: "Editing a template",
            tooltipText: "Editing a template",
            tooltipEvent: "Editing a template"
        },
        detailsTemplate: {
            btnText: "Template details",
            tooltipText: "Template details",
            tooltipEvent: "Template details"
        },
        formCompleteActivate: {
            btnText: "Enable completion",
            tooltipText: "Enable completion",
            tooltipEvent: "Enable completion"
        },
        formCompleteDeactivate: {
            btnText: "Disable completion",
            tooltipText: "Disable completion",
            tooltipEvent: "Disable completion"
        },
        timeRangeEdit: {
            btnText: "Editing of Times",
            tooltipText: "Editing of Times",
            tooltipEvent: "Editing of Times"
        },
        dataReview: {
            btnText: "Data review",
            tooltipText: "Data review",
            tooltipEvent: "Data review"
        },
        summaryDataReview: {
            btnText: "Summary data review",
            tooltipText: "Summary data review",
            tooltipEvent: "Summary data review"
        },
        back: {
            btnText: "Back",
            tooltipText: "Back",
            tooltipEvent: "Back"
        },
        usergroupEdit: {
            btnText: "User group description",
            tooltipText: "User group description",
            action: "User group description"
        },
        usergroupCreate: {
            btnText: "User group create",
            tooltipText: "User group create",
            action: "User group create"
        },
        accommodationRequestDetails: {
            btnText: "Accommodation request details",
            tooltipText: "Accommodation request details"
        },
        reloadCalendar: {
            btnText: "Calendar reload",
            tooltipText: "Calendar reload"
        },
        saveSettings: {
            btnText: "Save settings",
            tooltipText: "Save settings"
        },
        deleteWithForm: {
            btnText: "Delete including form / survey",
            tooltipText: "Delete including form / survey"
        },
        deleteFormWithRelatedRecords: {
            btnText: "Delete including completed forms",
            tooltipText: "Delete including completed forms"
        },
        formEdit: {
            btnText: "Form/survey edit",
            tooltipText: "Form/survey edit",
            tooltipEvent: "Form/survey edit"
        },
        formDetails: {
            btnText: "Form/survey details",
            tooltipText: "Form/survey details",
            tooltipEvent: "Form/survey details"
        },
        eventEdit: {
            btnText: "Event edit",
            tooltipText: "Event edit",
            tooltipEvent: "Event edit"
        },
        eventDetails: {
            btnText: "Event details",
            tooltipText: "Event details",
            tooltipEvent: "Event details"
        },
        participantDetails: {
            btnText: "Participant details",
            tooltipText: "Participant details",
            tooltipEvent: "Participant details"
        },
        download: {
            btnText: "Download",
            tooltipText: "Download document",
            tooltipEvent: "Download document"
        },
        eventLink: {
            btnText: "Open event"
        },
        rankingDetails: {
            btnText: "Ranking details",
            tooltipText: "Ranking details"
        },
        criteriaForEventEdit: {
            btnText: "Criteria for the event edit",
            tooltipText: "Criteria for the event edit",
            tooltipEvent: "Criteria for the event edit"
        },
        criteriaForEventEditDelete: {
            btnText: "Criteria for the event deletion",
            tooltipText: "Criteria for the event deletion",
            tooltipEvent: "Criteria for the event deletion"
        },
        admittedNotification: {
            btnText: 'Notify admitted',
            tooltipText: 'Notify admitted',
        },
        restart: {
            btnText: 'Restart',
            tooltipText: 'Restart'
        },
        mergeSelected: {
            btnText: "Merge selected",
            tooltipText: "Merge selected"
        },
        unmerge: {
            btnText: "Unmerge",
            tooltipText: "Unmerge"
        },
        summaryData: {
            btnText: "Summary data",
            tooltipText: "Summary data",
            action: "Summary data"
        },
        summaryDataReport: {
            btnText: "Summarized data report",
            tooltipText: "Summarized data report",
            tooltipEvent: "Summarized data report"
        },
        summaryDataReportNew: {
            btnText: "Summarized data report of completed participants",
            tooltipText: "Summarized data report of completed participants",
            tooltipEvent: "Summarized data report of completed participants"
        },
        summaryDataReportNewAnonymous: {
            btnText: "Summarized data report from anonymously completed surveys",
            tooltipText: "Summarized data report from anonymously completed surveys",
            tooltipEvent: "Summarized data report from anonymously completed surveys"
        },
        summaryDataReportNewAll: {
            btnText: "Summarized data report from all surveys",
            tooltipText: "Summarized data report from all surveys",
            tooltipEvent: "Summarized data report from all surveys"
        },
        newCertificates: {
            btnText: "NewCertificate",
            tooltipText: "NewCertificate",
            action: "NewCertificate"
        },
        syncWithFormEntityData: {
            btnText: "Sync with form data",
            tooltipText: "Sync with form data",
            action: "Sync with form data"
        },
        editWithNoValidation: {
            btnText: "Edit  with no validation",
            tooltipText: "Edit  with no validation",
            action: "Edit  with no validation"
        },
        links: {
            btnText: "Links",
            tooltipText: "Existing links"
        },
        confirmationRejectionDetails: {
            btnText: "Confirmation rejection details",
            tooltipText: "Confirmation rejection details"
        },
        replace: {
            btnText: "Replace",
            tooltipText: "Replace"
        },
        selectAll: {
            btnText: "Select all",
            tooltipText: "Select all"
        },
        unselectAll: {
            btnText: "Unselect all",
            tooltipText: "Unselect all"
        },
        notifySelected: {
            btnText: "Notify selected",
            tooltipText: "Notify selected",
            action: "Notify selected"
        },
        loadProfileData: {
            btnText: "Load profile data",
            tooltipText: "Load profile data",
            action: "Load profile data"
        },
        addLecturers: {
            btnText: "Add/Manage lecturers",
            tooltipText: "Add/Manage lecturers",
            action: "Add/Manage lecturers"
        },
        addParticipant: {
            btnText: "Add/Manage participants",
            tooltipText: "Add/Manage participants",
            action: "Add/Manage participants"
        },
        clearSelection: "Clear selection",
    },
    checkboxes: {
        exportWithData: {
            cbText: "Export with data"
        }
    },
    notifications: {
        error: "Error",
        success: "Success",
        successfulSavedData: "Data saved successfully",
        successfulDeletedData: "Data deleted successfully",
        errorDataNotSaved: "Data was not saved successfully",
        invalidUserCredentials: "Invalid credentials",
        serverError: "Server error. Please try again later",
        invalidData: "Invalid data",
        errorLoadingData: "Error while loading data",
        errorUploadingFiles: "Error while uploading files",
        successUploadingFiles: "Files uploaded successfully",
        certLoginRequiredEmail:
            "You must provide valid email address to log in to the system",
        duplicateEmail: "User with the same email already exists",
        warning: "Warning",
        dateFromBiggerThanDateTo: "Date from is bigger than date to",
        fieldValidationErrors:
            "There are fields with validation errors. Check out the form.",
        noEvent: "There is no event",
        noForm: "There is no form",
        thereIsNoConnectedEvent: "There is no connected event",
        thereIsNoConnectedForm: "There is no connected form/survey",
        invalidDateTimeRange: "The period Start/End of curriculum engagement is out of range for Start/End of event.",
        outOfRange: 'The period is out of event date/time range',
        leavePage: 'Do you really want to leave this page?',
        participationsWithAllowedCertificateNotAvailable: 'There aren\'t any participations for which creating new certificate option is active.',
        forbidden: '@:unauthorizedMessage',
        unauthorized: '@:unauthorizedMessage',
        validationError: 'There are validation errors'
    },
    editor: {
        tools: {
            panel: "Panel",
            textbox: "Textbox",
            datepicker: "Datepicker",
            dropdown: "Dropdown",
            toggle: "Toggle",
            personIdentification: "Person identification",
            fileUpload: "File upload",
            address: "Address",
            person: "Person",
            personList: "Person list",
            startRating: "Rating",
			evaluate: 'Evaluate'
        },
        panel: {
            editPanelName: "Edit panel name",
            panelName: "Panel name",
            panelNameEn: "Panel name (English)",
            panelLabel: "Label",
            panelLabelEn: "Label (English)",
            initialComponentName: "Initial name",
            initialComponentLabel: "Initial label",
			participationType: 'Participation type'
        },
        common: {
            id: "Id",
            name: "Name",
            nameEN: "Name (En)",
            normalizedName: "NormalizedName",
            label: "Label",
            labelEn: "Label (English)",
            textMinLength: "Text min length",
            textMaxLength: "Text max length",
            numberMinLength: "Min value",
            numberMaxLength: "Max value",
            textAllowNullOrEmpty: "Allow empty string",
            editComponentProperties: "Edit properties",
            type: "Field type",
            numberType: "Number type",
            minValue: "Min value",
            maxValue: "Max value",
            defaultValue: "Default value",
            numberFormat: "Number format",
            decimalPrecision: "Decimal precision",
            fieldCode: "Field code",
            create: "Create",
            read: "Read",
            update: "Update",
            delete: "Delete",
            add: "Add",
            saveAsTemplate: "Save as template",
            loadTemplate: "Load a template",
            fieldTemplate: "Field template",
            regex: "Regular expression",
            regexErrorText: "Error text for regular expression",
            regexErrorTextEn: "English error text for regular expression",
            description: "Description",
            descriptionEn: "Description (English)",
            showInDescription: "Show in description",
        },
        size: {
            length: "Length",
            small: "Small",
            medium: "Medium",
            large: "Large"
        },
        input: {
            typeText: "Text",
            typeNumber: "Number",
            typeTextarea: "Multiple rows text",
            intType: "Integer number",
            decimalType: "Real number"
        },
        dropdown: {
            chooseNomenclature: "Choose nomenclature",
            dropdownType: "Dropdown type",
            nomenclature: "Nomenclature",
            register: "Register",
            dynamicRegister: "Dynamic register",
            chooseRegister: "Choose register",
            chooseRegisterDisplayName: "Choose display column",
            isMultiDropdown: "Multiple choice",
            isCity: '"Settlements" type nomenclature'
        },
        errors: {
            loadNomenclaturesError: "Error loading nomenclatures data",
            loadStaticRegistersError: "Error loading registers data",
            loadDisplayMembersError: "Error loading display members",
            loadDynamicRegistersError: "Error loading dynamic registers"
        }
    },
    otherFields: {
        other1: "Other 1",
        other2: "Other 2",
        otherFields: "Other fields"
    },
    places: {
        title: "Venues",
        halls: "Halls",
        addHall: "Add hall",
        name: "Name",
        otherFields: "Other fields",
        location: "Location"
    },
    hall: {
        hall: "Hall",
        capacity: "Capacity"
    },
    toggle: {
        checked: "Yes",
        unchecked: "No"
    },
    finance: {
        pageTitle: "Tariff item",
        groups: "Groups",
        tariffItem: {
            title: "Tariff items",
            gridHeaders: {
                id: "Id",
                itemNumber: "Item N",
                groupId: "Group id",
                group: "Group",
                groupName: "Group name",
                groupNameEn: "Group name En",
                name: "Name",
                nameEn: "Name En",
                sort: "Sort number",
                description: "Description",
                specification: "Specification",
                package: "Package",
                code: "Code",
                deactivated: "Deactivated",
                active: "Active",
                deleted: "Deleted",
                qty: "Qty",
                singlePrice: "Single price no VAT",
                singlePriceWithTax: "Single price with VAT",
                maxPrice: "Max price no VAT",
                total: "Total",
                totalWithTax: "Total VAT",
                measure: "Measure"
            }
        },
        tariffEntity: {
            title: "Tariffs",
            gridHeaders: {
                id: "Id",
                contractId: "Contract ud",
                contract: "Contract",
                name: "Name",
                nameEn: "Name En",
                description: "Description",
                deactivated: "Deactivated",
                active: "Active",
                deleted: "Deleted",
                valid: "Valid"
            }
        },
        tabcontrol: {
            groups: "Groups",
            tariffItems: "Tariff items",
            tariffEntity: "Tariffs"
        }
    },
    searchBox: {
        placeholder: "Search...",
        noItemsFound: "Няма намерени резултати"
    },
    tasks: {
        activity: "Activity",
        answer: "Answer",
        history: "History",
        task: "Task",
        tasks: "Tasks",
        newTask: "New task",
        newTasks: "New tasks",
        notCompleted: "Started and uncompleted task|Started and uncompleted tasks",
        overdueTasks: "Overdue task|Overdue tasks",
        title: "Title",
        text: "Text",
        type: "Type",
        priority: "Priority",
        category: "Category",
        deadline: "Deadline",
        assignees: "Assignees",
        assigner: "Assigner",
        status: "Status",
        assignedToMe: "My tasks",
        createdByMe: "Assigned by me",
        updateTask: "Update task",
        editTask: "Edit task",
        timeToFinish: "Time to finish",
        assignedOn: "Assigned on",
        attachment: "Attachment",
        attachments: "Attachments",
        individualTask: "Individual task",
        individualTaskMessage:
            "Separate task will be generated for each of the selected assignees",
        groupTaskMessage:
            "Task will be one for all selected assignees. Each of them will be able to move it's implementation",
        changeTaskType:
            'Task type changed to group',
        groupTask: "Group task",
        startTask: "Start",
        taskStart: "Task start",
        taskStartMessage: "Are you sure you want to start the task?",
        completeTask: "Complete",
        taskCompletion: "Completed task",
        done_v: "Confirm",
        doneConfirm: "Are you sure you want to confirm task completion?",
        decline: "Refuse",
        taskDecline: "Task refusal",
        reason: "Reason",
        return: "Return",
        returnTask: "Task return",
        details: "Details",
        date: "Date",
        noAnswerMessage: "No answer yet",
        archive: "Archive",
        archived: "Archived",
        archive_v: "Archive",
        archiveMessage:
            "Are you sure you want to archive the taks? After been archived the task will not appear in lists and searches.",
        unarchive: "Unarchive",
        unarchive_v: "Unarchive",
        unarchiveMessage: `Are you sure you want to unarchive the taks? After been unarchived the task will appear in lists and searches.`,
        activities: {
            created: "created a task",
            edited: "made change",
            deleted: "deleted the task",
            started: "started the task",
            declined: "refuse the task",
            completed: "completed the task",
            confirmed: "confirmed task completion",
            returned: "returned the task for completion"
        },
        copy: "Copy",
        unfinished: "Unfinished tasks",
        switchWithReplacement:
            "The employee {0} is out of the office and {1} is his/her replacement. Do you wish the chosen employee to be replaced with his/her replacement?",
        switchNoReplacement:
            "The employee {0} is out of the office and there is no replacement. Do you wish the chosen employee to be removed from the list?",
        createNewSingingTask: "Create new signing task"
    },
    coordinations: {
        accept: "Approve",
        answer: "Answer",
        attachments: "Attachments",
        pageTitle: "Coordination procedures",
        title: "Title",
        newCoordination: "New coordination",
        newCoordinations: "New coordinations",
        uncompleted: "Uncompleted coordination|Uncompleted coordinations",
        overdueCoordinations: "Overdue coordination|Overdue coordinations",
        edit: "Edit",
        assignedToMe: "Started procedures",
        createdByMe: "Created by me",
        agreedByMe: "Agreed by me",
        approve_n: "Approve",
        approved: "Approved",
        refuse_n: "Refuse",
        requestLink: 'Request (link)',
        change_request: "Change request",
        comments: "Comments",
        comment: "Comment",
        commentMessage: "The comment will be included in your answer",
        deadline: "deadline",
        type: "Coordination type",
        coordinators: "Coordinators",
        noCoordinatorsMsg: "No coordinatord added",
        coordDoc: "Document to coordinate",
        innerType: "Internal",
        innerTypeMessage:
            "The coordination does not need outgoing number from DMS.",
        ongoing: "ongoing...",
        outgoingType: "Outgoing",
        outgoingTypeMessage:
            "The coordination must have outgoing number from DMS. The clerk must finish the procedure",
        clerk: "Clerk",
        start: "Start",
        startTitle: "Start the coordination procedure",
        startMessage:
            "Are you sure, you want to start the coordination procedure?",
        status: "Status",
        reject: "Reject",
        rejected: "Rejected",
        result: "Result",
        deletionConfirmMessage:
            "Are you sure, you want to delete the coordination procedure?",
        startedBy: "Started by",
        createdBy: "Created by",
        archive: "Archive",
        archived: "Archived",
        archive_v: "Archive",
        archiveMessage:
            "Are you sure, you want to archive the coordination procedure? After the archivation it will not appear in lists and searches.",
        unarchive: "Unarchive",
        unarchive_v: "Unarchive",
        unarchiveMessage:
            "Are you sure, you want to unarchive the coordination procedure? After the unarchivation it will appear in lists and searches.",
        activities: {
            created: "created coordination procedure",
            edited: "made change",
            deleted: "deleted the coordination procedure",
            started: "started coordination procedure",
            approved: "approved coordination request",
            rejected: "rejected coordination request",
            completed: "coordination procedure completed",
            confirmed: "confirmed coordination procedure",
            archived: "archived coordination procedure",
            unarchived: "unarchived coordination procedure",
            canceled: "canceled coordination procedure"
        },
        notYourTurn:
            "You are not allowed to perform this action in this coordination procedure",
        notFound:
            "The coordination was not found or you do not have reequred permissions",
        cancel: "Cancel",
        cancelConfirm: "Are you sure you want to cancel this procedure?",
        cancelation: "Cancelation",
        cancelationReason: "Cancelation reason",
        createFromOrganizationalDocuments: "Create a coordination procedure from the selected documents",
        organizationalDocumentsCoordinationCreateConfirmation: "Are you sure you want to create the coordination procedure from the selected organizational documents?",
    },
    planning: {
        planning: "Planning",
        includeInAnnualCatalog: "Include in annual catalog",
        theme: "Theme",
        alternativeName: "Alternative name",
        legalArea: "Legal area",
        lectorsProposal: "Lecturers proposals",
        passEventsForTheme: "Passed events for the theme",
        passEventsLectorsForTheme: "Passed events lecturers",
        pushForCoordination: "Push for coordination",
        addToAnnualCatalog: "Add to annual catalog",
        year: "Year",
        haveNo: "N/A",
        join: "Join",
        addToAnnualCatalogProject: "Add to annual catalog project",
        themes: "themes",
        _for: "for",
		noThemesFound: 'No themes found',
		filter: 'Filter',
		from: 'From',
		to: 'To',
		load: 'Load',
		changingDataWarning: 'Change will cause reloading data and loosing all changes',
        validationError: 'Validation error',
        pleaseFixValidationErrors: 'Please fill the required fields'
    },
    organizationalProposals: {
        title: 'Organizational proposals',
        proposal: 'Proposal',
        proposedBy: 'Proposed by',
        date: 'Date'
    },
    annualCatalog: {
        annualCatalogProject: "Annual catalog project",
        annualCatalog: "Annual catalog",
        noData: "No data",
        createdDate: "Date created",
        createdUser: "Created by",
        thereIsCreatedAnnualCatalog:
            "There is already created annual catalog for",
        year: "year",
        approved: "Approved",
        on: "on",
        coordination: 'Coordination'
    },
    presenceForm: {
        title: "Presence form",
        absence: "Absence",
        absenceType: "Absence type",
        replacement: "Replacement",
        period: "Period",
        noData: "No data",
        dateAbsence: "From",
        dateEndAbsence: "To",
        removeAbsence: "Remove",
        removeAllAbsence: "Remove all",
        reasonForAbsence: "Absence reason",
        reasonForReplacement: "Replacement reason",
        creatorUsername: "Created by",
        restDay: "Rest day",
        removeAbsenceConfirm:
            "Are you sure you want to remove the selected absence for the selected date?",
        removeAllAbsenceConfirm:
            "Are you sure you want to remove all absences for the selected date?"
    },
    scheduler: {
        agenda: "Curriculum",
        management: "Hall calendar management",
        appointment: "Curriculum engagement",
        appointmentCreate: "Creating a curriculum engagement",
        appointmentEdit: "Curriculum engagement editing",
        title: "Title",
        description: "Description",
        calendar: "Hall schedule",
        gridHeaders: {
            id: "Id",
            date: "Date",
            eventName: "Event",
            startDate: "Start time",
            endDate: "End time",
            timeRange: "Time range"
        },
        invalidEventSelection: "Invalid event selection!",
        invalidVenueSelection: "Invalid venue selection!",
        invalidHallSelection: "Invalid hall selection!",
        venue: "Venue",
        hall: "Hall",
        mapVenueToEventCheck: "Filter the list of venues by the selected event",
        hideFromDescription: "Hide from description",
        capacity: "Capacity",
        isAllDay: "All day",
        lecturers: "Lecturers",
        coordinators: "Coordinators",
        lecturersHelpBlock: "Lecturers added to the corresponding event",
        coordinatorsHelpBlock: "Coordinators added to the corresponding event",
        deleteConfirm: "Are you sure you want to delete the record with title ",
        isDailyEven: "Daily event",
        dailyEventStartTime: "Daily event start time",
        dailyEventEndTime: "Daily event end time",
        hallHelpBlock: 'Active if "Venue" is selected',
        venueHelpBlock:
            "Selecting the checkbox above will filter according to the selected venues for the selected event. See General Information section, Venue panel.",
        saveAnyway: 'Ignore date difference check between event and curriculum'
    },
    budget: {
        needSavedEvent: "Event must be save first",
        name: "Name",
        nameEn: "English name",
        tariffItem: "Tariff item",
        date: "Date",
        quantity: "Qty",
        singlePrice: "Single price",
        total: "Total",
        group: "Group",
        new: "New",
        edit: "Edit",
        generateExpenses: "Generate expenses",
        expensesGenerated: "Expenses generated",
        budgetFor: "Budget for",
        expensesPersonOrCompany: "Person or company for the expense",
        areYouSureYouWantToGenerateExpenses:
            "Are you sure you want to generate expenses?",
        youCanGenerateExpensesOnce: "Expenses can be generated only once",
        description: "Description",
        deactivationSuccess: 'Deactivation success',
        activationSuccess: 'Activation success',
        deactivationUnSuccess: 'Deactivation unsuccessful',
        activationUnSuccess: 'Activation unsuccessful'
    },
    budgetReport: {
        participants: "Participants",
        businessTripOrderNumber: "Order numb",
        businessTrip: "Business trip",
        businessTripFrom: "Business trip from",
        businessTripTo: "Business trip to",
        daysCount: "Days count",
        daysRate: "Money day rate",
        daysRateSum: "Sum",
        nights: "Nights",
        nightsFrom: "Nights from",
        nightsTo: "Nights to",
        nightsCount: "Nights count",
        singlePrice: "Single price",
        apartmentSum: "Sum",
        roadGoingMoney: "Road going money",
        date: "Date",
        roadReturningMoney: "Road returning money",
        roadMoneyAll: "Road money total",
        all: "All",
        payedWithoutApartment: "Paid expenses",
        paymentDate: "Payment date",
        excerpt: "Excerpt",
        accountingProgram: "Accounting program",
        difference: "Difference",
        note: "Note",
        financialControl: "Financial control",
        markAllAsFinancialControl: "Mark all as financial control"
    },
    budgetTemplate: {
        title: "Budget templates"
    },
    budgetModule: {
        plan: "Plan",
        expense: "Expense",
        financing: "Financing",
        balance: "Balance",
        budgetPosition: "Budget position",
        qty: "Qty",
        singlePriceByTariff: "Single price by tariff",
        total: "Total",
        totalNijFinancing: "Nij financing total",
        totalExternalFinancing: "External financing total"
    },
    budgetModuleReport: {
        budgetQty: "Budget - Qty",
        budgetPrice: "Budget - Price",
        budgetTotal: "Budget - Total",
        expenseQty: "Expense - Qty",
        expensePrice: "Expense - Price",
        expenseTotal: "Expense - Total",
        balance: "Balance",
        budgetPosition: "Budget position",
        total: "Total",
        groupTotalBudget: "Budget - Total by group",
        totalBudget: "Budget - Total",
        groupTotalExpense: "Expense - Total by group",
        totalExpense: "Expense - Total",
        title: 'Budget module - report'
    },
    calendar: {
        title: "Calendar",
        itemType: "Item Type",
        eventFilter: "Event filter",
        taskFilter: "Task filter",
        itemFilter: "Calendar item filter"
    },
    organizationalCalendar: {
        title: "Organizational calendar",
        modelsLoading: "Loading model(s)",
        missing: "No organizational calendar created.",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            description: "Description",
            applied: "Applied",
            createdAt: "Creation time"
        },
        applyConfirmation:
            "Are you sure you want to apply the selected organizational calendar?"
    },
    organizationalModel: {
        title: "Organizational model",
        titles: "Organizational models",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            description: "Description",
            deactivated: "Deactivated",
            active: "Active",
            loaded: "Loaded",
            eventForms: "Event form",
            eventActivities: "Event activity/direction"
        },
        edit: "Organizational model / Edit",
        eventForm: "Form of the event",
        eventActivity: "Activity / Direction of the event",
        deactivateConfirm:
            "Are you sure you want to deactivate the organizational model ",
        activateConfirm:
            "Are you sure you want to activate the organizational model "
    },
    organizationalModelItem: {
        title: "Organizational model element",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            expectedResult: "Expected result",
            deactivated: "Deactivated",
            active: "Active",
            categoryDisplayName: "Category",
            priorAlertDeadlineInDays:
                "Offset in days by deadline to generate alert to coordinators",
            deadlineToAfterBenchemarkIdDays:
                "Deadline as a day offset from the starting point",
            benchmarkType: "Benchmark  type"
        }
    },
    organizationalCalendarItem: {
        title: "Organizational calendar element",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            expectedResult: "Expected result",
            deactivated: "Deactivated",
            active: "Active",
            categoryDisplayName: "Category",
            priorAlertDeadlineInDays:
                "Offset in days by deadline to generate alert to coordinators",
            deadlineToAfterBenchemarkIdDays:
                "Deadline as a day offset from the starting point",
            benchmarkType: "Benchmark  type",
            deadline: "Deadline",
            alertDate: "Alert date",
            printDate: "Print date",
            applied: "Applied",
            completedTask: "Completed task",
            completionTime: "Completion time"
        },
        applyConfirmation: "Are you sure you want to apply an item ",
        deleteConfirmation: "Are you sure you want to delete an item ",
        taskAlreadyCompleted: "The task has already been completed!",
        completeTask: "Complete"
    },
    reportData: {
        events: {
            menuTitle: "Events",
            title: "Report data / Events",
            eventId: "ID",
            migrationEventId: "ID (migration)",
            migrationEventStartDate: "Start date (migration)",
            migrationEventStartDateHour: "Start hour (migration)",
            eventStartDate: "Start date",
            eventStartDateHour: "Start hour",
            migrationEventEndDate: "End date (migration)",
            migrationEventEndDateHour: "End hour (migration)",
            eventEndDate: "End date",
            eventEndDateHour: "End hour",
            eventDirectorateId: "DirectorateId",
            migrationEventDirectorate: "Directorate (migration)",
            eventDirectorate: "Directorate",
            migrationEventActivityDirection: "Activity (Direction) (migration)",
            eventActivityDirectionId: "ActivityDirectionId",
            eventActivityDirection: "Activity (Direction)",
            migrationEventLegalArea: "Legal area (migration)",
            eventLegalArea: "Legal area",
            migrationEventFundingType: "Funding type (migration)",
            eventFundingType: "Funding type",
            migrationEventProjectName: "Project name (migration)",
            eventProjectId: "ProjectId",
            eventProjectName: "Project name",
            migrationEventOrganizerName: "Organizer (Partner) (migration)",
            eventOrganizerName: "Organizer (Partner)",
            migrationEventSort: "Event sort (migration)",
            еventSortId: "SortId",
            eventSort: "Event sort",
            migrationEventName: "Event name (migration)",
            eventName: "Event name",
            migrationThematicArea: "Thematic area (migration)",
            thematicArea: "Thematic area",
            migrationContactPersons: "Contact persons (migration)",
            contactPersons: "Contact persons",
            migrationEventVenue: "Event venue (migration)",
            eventVenue: "Event venue",
            migrationEventLocation: "Event location (migration)",
            eventLocation: "Event location",
            migrationLecturers: "Lecturers (migration)",
            lecturers: "Lecturers",
            migrationParticipantsMaxNum: "Participants max count (migration)",
            participantsMaxNum: "Participants max count",
            migrationEventAudience: "Audience (migration)",
            eventAudience: "Audience",
            migrationHotelName: "Hotel name (migration)",
            hotelName: "Hotel name",
            migrationHotelAddress: "Hotel address (migration)",
            hotelAddress: "Hotel address",
            migrationLastDayForBooking:
                "Last day for accommodation request (migration)",
            lastDayForBooking: "Last day for accommodation request",
            migrationEventStayFrom: "Accommodation from (migration)",
            eventStayFrom: "Accommodation from",
            migrationEventStayTo: "Accommodation to (migration)",
            eventStayTo: "Accommodation to",
            migrationEventDailyAllowanceFrom:
                "Daily allowance from (migration)",
            eventDailyAllowanceFrom: "Daily allowance from",
            migrationEventDailyAllowanceTo: "Daily allowance to (migration)",
            eventDailyAllowanceTo: "Daily allowance to",
            migrationNoteStatus: "Status notes (migration)",
            noteStatus: "Status notes",
            migrationEventSubscriptionStartDate:
                "Subscription start date (migration)",
            eventSubscriptionStartDate: "Subscription start date",
            migrationEventSubscriptionEndDate:
                "Subscription end date (migration)",
            eventSubscriptionEndDate: "Subscription end date",
            migrationExcludeFromReporting: "Exclude from reporting (migration)",
            excludeFromReporting: "Exclude from reporting",
            migrationEventStatus: "Event status (migration)",
            statusId: "StatusId",
            eventStatus: "Event status",
            migrationCreatedByUserName: "Created by (migration)",
            createdByUserName: "Created by",
            migrationCreatedAt: "Created at (migration)",
            createdAt: "Created at",
            migrationUpdatedByUserName: "Updated by (migration)",
            updatedByUserName: "Updated by",
            migrationUpdatedAt: "Updated at (migration)",
            updatedAt: "Updated at",
            migrationEventNote: "Notes (migration)",
            eventNote: "Notes",
            eventDescription: "Description",
            eventExpectedResults: "Expected results",
            eventLearningGoals: "Learning goals",
            eventMainActivity: "Main activity",
            archived: "Archived",
            coordinators: "Coordinators",
            eventForm: "Event form",
            shortDates: "Short dates",
            eventContactPerson: "Contact persons",
            eventLabel: "Labels",
            eventCode: 'Event code'
        },
        participants: {
            menuTitle: "Participants",
            pageTitle: "Report data / Participants",
            participantId: "Id",
            participantMigrationId: "ID (migration)",
            registerEntityId: "EventId",
            eventMigrationId: "EventId (migration)",
            partRequsetFillDate: "Request fill date",
            gender: "Gender",
            title: "Title",
            salutation: "Salutation",
            egn: "EGN",
            firstName: "First name",
            middleName: "Middle name",
            lastName: "Last name",
            fullName: "Name",
            position: "@:person.position",
            migrationInstitutionName: "Institution (migration)",
            migrationInstitutionCity: "Institution location (migration)",
            institutionName: "Institution",
            institutionCity: "Institution location",
            phone: "Phone",
            mobilePhone: "Mobile phone",
            email: "Email",
            participationCode: "Participation (Code)",
            participationName: "Participation",
            reasonForAdmission: "Reason for admission",
            deployed: "Deployed",
            cityOfCurrentAddress: "City of current address",
            accommodationRequest: "Accommodation request",
            datesForNights: "Accommodation dates",
            roomType: "Room type",
            travelers: "Subsistence money",
            vegetarianMenu: "Vegetarian menu",
            note: "Notes",
            positionStatistics: "@:person.positionStatistic",
            isMigrant: "Migrant",
            isForeigner: "Foreigner",
            isMemberOfAMinority: "Member of minority",
            isOfGypsyOrigin: "Of gypsy origin",
            withDisabilities: "With disabilities",
            isHomeless: "Homeless",
            isDisadvantaged: "Disadvantaged",
            isFromUnemployedHousehold: "From unemployed household",
            withDependentChildren: "With dependent children",
            fromOneMemberHousehold: "One member household",
            createdByUserName: "Created by",
            createdAt: "Created at",
            updatedByUserName: "Updated by",
            updatedAt: "Updated at",
            employment: "Employment",
            education: "Education",
            consentToBeProcessed: "Consent to be processed",
            participationTypeName: "Participation type",
            statusName: "Participation status",
            deleted: "Deleted",
            currentSettlement: "Current settlement",
            positionFullName: "@:person.positionFullName",
            areaOfAppeal: 'Area of Appeal'
        },
        participantsToMigrationTitle: "Participants and their migration dataя"
    },
    aspNetRole: {
        name: "Name",
        description: "Description",
        active: "Active",
        deactivated: "Deactivated",
        confirm: {
            delete:
                "Are you sure you want to delete the role? All related User-Role and User-Role-Right links will be deleted!"
        }
    },
    yearRangeSelector: {
        all: "All",
        curentYear: "Current year",
        previousYear: "Previous year"
    },
    aspNetUser: {
        create: "User create",
        edit: "User edit"
    },
    timer: {
        labels: {
            days: "Days",
            hours: "Hours",
            minutes: "Minutes",
            seconds: "Seconds"
        }
    },
    home: {
        myLastPaticipations: "My last participations",
        event: "Event",
        participation: "Participation type",
        startTime: "Start date",
        endTime: "End date",
        noData: "No data found",
        showMore: "Show more",
        myForms: "Completed surveys and forms",
        form: "Survey/Form",
        type: "Type",
        myLastActionLogs: "My last actions"
    },
    participationType: {
        title: "Participation type",
        create: "Participation type creation",
        edit: "Participation type edit",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            description: "Description",
            isParticipation: 'Meaning "Student"',
            isLecturerType: 'Meaning "Lecturer"',
            isCoordinatorType: 'Meaning "Coordinator"',
            deactivated: "Deactivated",
            active: "Active",
            participationRelationType: "Ground for participation",
            reasonForAdmission: "Reason for admission / non-admission",
        }
    },
    dropdownList: {
        noDataFound: "No data found.",
        createQuestion: "Do you want to add a new item?"
    },
    claims: {
        title: "Roles",
        evenatClaimsAdministration: "Event claims administration",
        existingClaims: "Existing claims",
        loadedClaims: "Loaded claims",
        eventClaimsInfo:
            "Event rights list. Giving a right to a particular type of participation determines the rights to work with the relevant section. The rights are first inherited from the user`s user group, and then from his role in the event"
    },
    benchmarkType: {
        title: "Benchmark type / Administration",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            code: "Code",
            deactivated: "Deactivated"
        }
    },
    certificates: {
        number: "certificate №",
        personName: "Name, position, institution",
        eventName: "Event",
        eventCode: "Event code",
        evaluation: "Evaluation",
        validFrom: "Valid from",
        validTo: "Valid to",
        createdOn: "Created on",
        createdBy: "Created by",
        title: "Certificates",
        certificate: "Certificate",
        download: "Download",
        delete: "Delete",
        deletion: "Deletion",
        eventId: "Event id",
        deletionMessage: "Are you sure, you want to delete this certificate?",
        template: {
            noData: "Certificate templates",
            title: "Used certificate template",
            label: "Template name",
            help: "Determines which template will be used to generate certificates for participation in the event. The ones published in the 'Certificates' category or the one defined in the application configuration settings are loaded.",
        },
        help:
            'The option to issue a new certificate is active under the following conditions: The type of participation is "Participant" and the status of participation is "Completed with certificate".',
        moodleCertificateHelp: 'Участници в Mудъл, които имат завършена дейност "Удостоверение за завършено обучение" или както e именувана допълнителната добавка за издаване на сертификати(modname="customcert"). Ако допълнителната дейност е заключена или не е видима няма да се заредат данни, поради невъзможност да се прочетат от Мудъл.',
    },
    upcomingEvents: {
        title: "Upcoming events",
        description: "Possible actions for upcoming events",
        gridHeaders: {
            id: "Id",
            name: "Event",
            startTime: "Start date",
            endTime: "End date",
            statuses: "Statuses"
        },
        noData: "No records found",
        completeSubsForm: "Complete an event participation request",
        editSubsForm: "Edit an event participation request",
        participationRequestConfirmation:
            "Confirmation of request to participate",
        participationRequestRejection: "Rejection of request to participate",
        notificationSubsciption:
            "Subscribe to notification when enrollment is activated",
        notificationUnsubsciption:
            "Unsubscribe to notification when enrollment is enabled",
        confirmations: {
            notificationSubsciption:
                "Are you sure you want to subscribe to a notification when you activate a request to participate in the selected event?",
            notificationUnsubsciption:
                "Are you sure you want to remove the subscription for notification when enrollment is enabled for the selected event?"
        },
        email: "Email",
        note: "Note",
        help: {
            upcomingEvent: "An upcoming event is considered to be one that is public, no date has been entered for the start of the event or it has not occurred. Upcoming events are visible to users with the required right (UpcomingEvent.Read).",
            subscriptionForEvent: "The button for applying for participation is visible in the presence of the necessary right(FormSurveyEntity.Create) and there is a form of type 'Application for participation', which is active to fill in.",
            subscriptionForEventEdit: "The button to edit the application for participation is visible in the presence of the above conditions and the user has filled in a form for 'Application for participation'.",
            notificationSubsciption: "The button to '@:upcomingEvents.notificationSubsciption' is visible for '@:upcomingEvents.title' for which no form of type 'Application for participation' has been created."
        },
        wrongEmailInfo: "Email is taken from profile data. If it is wrong, it can be changed in Profile/Personal data."
    },
    participationConfirmation: {
        modalTitle: "Confirmation of participation",
        accommodationRequired: "Accommodation requred",
        transportationRequired: "Transportation required",
        vegetarianMenuRequired: "Vegetarian menu required",
        note: "Note",
        fromDate: "From",
        toDate: "To",
        fromDateDescription: 'Enter the first day',
        toDateDescription: 'Enter leaving day / date',
        accommodationPlace: "Accommodation place",
        accommodationType: "Accommodation type",
        accommodationRequiredHelp: "",
        transportationRequiredHelp: "",
        vegetarianMenuRequiredHelp: "",
        notification: "Event: {eventName} / From: {personName}"
    },
    participationRejection: {
        modalTitle: "Rejection of participation",
        notification: "Event: {eventName} / From: {personName}"
    },
    notificationsPopup: {
        eventAdded: {
            title: "An event added"
        },
        eventUpdated: {
            title: "An event updated"
        },
        eventDeleted: {
            title: "An event deleted"
        },
        participantAdded: {
            title: "An event participant added"
        },
        participantUpdated: {
            title: "An event participant updated"
        },
        participantDeleted: {
            title: "An event participant deleted"
        },
        taskAdded: {
            title: "A task added"
        },
        taskUpdated: {
            title: "A task updated"
        },
        taskDeleted: {
            title: "A task deleted/archived"
        },
        registerImport: {
            errorTitle: "Error on importing!"
        }
    },
    participationRelationType: {
        title: "Ground for participation",
        create: "Ground for participation creation",
        edit: "Ground for participation edit",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            description: "Description",
            sort: "Sort order",
            deactivated: "Deactivated",
            active: "Active",
            participationTypes: "Participation type",
            participationTypesEn: "Participation type EN"
        }
    },
    reasonForAdmission: {
        title: "Reason for admission / non-admission",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            note: "Note",
            deactivated: "Deactivated",
            active: "Active",
            sort: "Sort number",
            participationType: "Participation type"
        }
    },
    registerStatus: {
        title: "Event status",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            deactivated: "Deactivated",
            active: "Active",
            isCompleted: "Means completed"
        }
    },
    localization: {
        bgTitle: "Label texts in Bulgarian",
        enTitle: "Label texts in English",
        bgJsonSchemaError: 'Invalid json schema of "@:localization.bgTitle"',
        enJsonSchemaError: 'Invalid json schema of "@:localization.enTitle"',
        help:
            "Multiple Key:Value object. Editable are only values. The keys must not be changed! It is necessary to maintain a valid json object structure!"
    },
    applicationSettings: {
        title: "@:sideMenu.applicationSettings",
        userSettings: {
            title: "Потребителски настройки",
            registrationDefaultUserRole: "Default role",
            help: {
                registrationDefaultUserRole:
                    "Defines the default role that each self-registered user receives"
            }
        },
        eventSettings: {
            title: "Event settings",
            createNewFormOnAddToEvent:
                "Create a new form when adding a template to an event",
            checkEventTimeRangeOnFormAddToEvent:
                "Check to overlap the activity period of the event and the activity period of the form",
            checkEventSubscriptionTimeRangeOnFormAddToEvent:
                'Check for overlap of the period of activity of the "Application / registration button" (section "General data") and the period of activity of the form',
            skipRankingQuotaEvaluation:
                "Exclude quota evaluation when generating temp ranking",
            rankWithNoneQuotes: "Ranking of applications for participation not included in any quota",
            rerankDropoutFromQuota: "Ranking of those who dropped out of the quota for the remaining vacancies",
            moodleEventNameComposingPattern: "Pattern for composing the full name of a Moodle course",
            filterParticipationRelationTypeByParticipationType: "Filter '@:participationRelationType.title'",
            createInstitutionOnParticipantsImport: "Creation of entries in the registry '@:institution.title' when importing participants from excel.",
            accommodationRequestDaterangeMinLimitToFieldRelation: "Dynamic field code specifying the minimum value of the control for selecting dates of accommodation",
            accommodationRequestDaterangeMaxLimitToFieldRelation: "Dynamic field code determining the maximum value of the control for selecting dates for accommodation",
            accommodationRequestDaterangeLimitToEventsSkip: "Event excluded from check-in dates for accommodation",
            help: {
                createNewFormOnAddToEvent: "",
                checkEventTimeRangeOnFormAddToEvent: "",
                checkEventSubscriptionTimeRangeOnFormAddToEvent: "",
                skipRankingQuotaEvaluation: "When creating a temp ranking, the quotas included in the criteria will not be evaluated. The ranking will be done according to general criteria (points and time of submitting the application for participation).",
                rankWithNoneQuotes: "In the presence of quotas in the ranking criteria will allow those absent in any quota to be ranked for the remaining vacancies. Those absent from the quota are those who do not meet the requirements for a quota, not those who are outside the permitted quota number.",
                rerankDropoutFromQuota: "Those who drop out above the maximum allowable quota participate in the ranking for the remaining vacant places according to general criteria (points and time of submission of the application for participation).",
                moodleEventNameComposingPattern: "",
                filterParticipationRelationTypeByParticipationType: "Filter '@:participationRelationType.title' dropdown list by '@:participationType.title' selection",
                filterReasonForAdmissionByParticipationType: "Filter '@:reasonForAdmission.title' dropdown list by '@:participationType.title' selection",
                createInstitutionOnParticipantsImport: "Allows the creation of entries in the registry '@:institution.title' when importing participants from excel."
            }
        },
        isupoSettings: {
            title: "Isupo settings",
            schema: "Shema",
            hostName: "Host name",
            migrateParticipantsInSingleStatement:
                "Migrate participants in sigle SQL statement",
            migrateParticipantsBatchSize: "Batch size of the SQL statement",
            showDraftReports: "Show unpublished reports (in draft)",
            loadLocalizationFromDb:
                "Load the localization source from the database",
            includeMergedProfiles: "Include merged profiles in the search",
            help: {
                schema: "",
                hostName: "",
                migrateParticipantsInSingleStatement: "",
                migrateParticipantsBatchSize: "",
                showDraftReports: "",
                loadLocalizationFromDb: "",
                includeMergedProfiles:
                    "Determines whether to load merged persons in the person search/load component."
            }
        },
        signingSettings: {
            title: "QES signing settings",
            certificateDefaultAssigneeUsername: "Default certificate assagnee username",
            defaultPdfSignatureVisualizatonType: "Default PDF signature visualization type",
            defaultPdfReason: "PDF default signature reason",
            defaultPdfContact: "PDF default signature contact",
            defaultPdfLocation: "PDF default signature location",
            defaultPdfRectagle: "PDF default signature rectangle coords",
            pdfSignatureVisualizationIsVisible: "Signature visualization is visible",
            defaultDocxName: "Default DOCX name",
            defaultDocxTitle: "Default DOCX title",
            defaultDocxEmail: "Default DOCX email",
            pdfReason: "PDF signature reason",
            pdfContact: "PDF signature contact",
            pdfLocation: "PDF signature location",
            pdfRectangle: "PDF signature rectangle coords",
            reportingTemplateName: "Template name",
            addReportingTemplate: "Add template",
            reportingTemplatePdfSignatureVisualizatonType: "PDF signature visualization type",
            username: "Username",
            bookmarkId: "Bookmark ID",
            addUserSettings: "Add user settings",
            turnOnCertificateSigning: "Turn on certificate signing"
        },
        formSetiings: {
            title: "Form settings",
            formTypesWithAnonymousFillingAllowed: 'Forms with anonymous filling allowed'
        }
    },
    report: {
        title: "Document generation",
        category: "Category",
        report: "Report",
        params: "Parameters",
        generate: "Generate",
        newGeneratedDoc: "New document from template",
        format: "Document type",
        chooseFormat: "Select document type",
        template: "Template",
        docTitle: "Document title",
        docTitleInfo:
            "Generated document will be stored in the database with this title.",
        grid: {
            title: "Title",
            type: "Type",
            generatedBy: "Generated by",
            generatedOn: "Generated on",
            actions: "Actions",
            isPublic: "Public"
        }
    },
    formsFilterSource: {
        all: "All",
        templates: "Templates",
        notTamplates: "Not templates"
    },
    documentsUpload: "Documents upload",
    uploadExistingDocs: "Upload existing Documents",
    rankingCriteria: {
        title: "@:sideMenu.rankingCriteria",
        create: "@:buttons.create.btnText на @:rankingCriteria.title",
        edit: "@:buttons.edit.btnText на @:rankingCriteria.title",
        details: "@:buttons.details.btnText на @:rankingCriteria.title",
        gridHeaders: {
            id: "Id",
            name: "Name",
            nameEn: "Name En",
            other1: "Other 1",
            other2: "Other 2",
            deactivated: "Deactivated",
            creatorUsername: "Created by",
            createdAtUtc: "Created at",
            updaterUsername: "Updated by",
            updatedAtUtc: "Updated at",
            eventForm: 'Event form',
        },
        editor: {
            name: "@:rankingCriteria.gridHeaders.name",
            nameEn: "@:rankingCriteria.gridHeaders.nameEn",
            other1: "@:rankingCriteria.gridHeaders.other1",
            other2: "@:rankingCriteria.gridHeaders.other2",
            deactivated: "@:rankingCriteria.gridHeaders.deactivated",
            rules: "Rules",
            exceptions: "Exceptions",
            firstInTimeFirstInLaw: "First in time - first in law",
            manuallyAdded: "Manually added",
            constraints: "Constraints",
            evaluations: "Evaluations",
            quotas: "Quotas",
            type: "Type",
            kind: "Kind",
            score: "Score",
            count: "Count",
            appellateRegion: "@:institution.appellateRegion",
            institution: "@:institution.information",
            position: "@:person.position",
            professionalOrientation: "@:person.positionStatistic",
            fieldValue: "Field value",
            operator: "Operator",
            min: "Min",
            max: "Max",
            notParticipatesInOverlappingEvent:
                "Does not participate in another overlapping event",
            hasConsentOfTheManager: "There is the consent of the head",
            isCurrentYear: "Current year",
            from: "From",
            to: "To",
            audience: "Audience",
            copyToRegister: "Мake a copy to the register",
            searchFieldName: "Search field name",
            eventForm: 'Event form',
            help: {
                searchFieldName: "Determines which field of the participation request form will be used when applying the quota",
                searchValue: "The multiple choice is separated by a '/' delimiter. The value will be translated as OR.",
            }
        },
        confirmations: {
            create: "Are you sure you want to create ranking criteria ",
            edit: "Are you sure you want to edit ranking criteria ",
            delete: "Are you sure you want to delete ranking criteria ",
            addToEvent:
                "Are you sure you want to add the selected ranking criteria?"
        },
        help: {
            copyToRegister:
                "Copy the ranking criteria to the 'Ranking Criteria' register"
        }
    },
    participationRequest: {
        title: "Applications for participation",
        gridHeaders: {
            id: "Id",
            name: "Name",
            username: "Username",
            email: "Email",
            position: "@:person.position",
            positionStatistic: "@:person.positionStatistic",
            positionStr: "@:person.positionFullName",
            institutionName: "Institution",
            institutionCity: "Institution location",
            createdAtUtc: "Created at",
            updatedAtUtc: "Updated at",
            formName: "Form name",
            formType: "Form type",
            status: "Satus",
            eventName: "Event name"
        }
    },
    sentEmails: {
        title: "@:sideMenu.sentEmails",
        gridHeaders: {
            Subject: "Subject",
            Body: "Body",
            To: "To",
            Cc: "Cc",
            Bcc: "Bcc",
            CreatedBy: "Created by",
            Errors: "Error details",
            Note: "Note",
            CreatedAtUtc: "Created at",
            SentTimeUtc: "Sent time",
            ErrorTimeUtc: "Error time",
            HasError: "Error",
            OtherNotification: "Other notification",
            OtherNotificationAt: "Other notification at",
            UninformedParticipants: "Uninformed participants",
            NotifiedAt: 'Notified at',
            Notified: 'Notified'
        }
    },
    eventDocuments: {
        title: "Generated report templates from events",
        eventDocsGrid: {
            documentId: "ID",
            fileName: "File name",
            docType: "Type",
            createdBy: "Generated by",
            createdOn: "Generated on",
            registerEntityId: "Event ID",
            eventName: "Event",
            eventStartDate: "Event start",
            eventEndDate: "Event end",
            eventLocation: "Event location",
            eventMainActivity: "Main activity",
            eventActivityDirection: "Direction",
            eventDirectorate: "Directorate",
            eventProjectName: "Project",
            actions: "Actions",
            openEvent: "Go to event",
            eventCode: "Event code",
            eventSubscriptionStartDate: "Enrollment start",
            eventSubscriptionEndDate: "Enrollment end",
            eventStatus: "Status",
            eventForm: "Event format",
            eventSort: "Event sort",
            eventVenue: "Event venue",
            eventOrganizerName: "Organizer / Partner",
            eventLegalArea: "Juridical area",
            eventFundingType: "Financing",
            eventNote: "Note",
            thematicArea: "Thematic area",
            theme: "Theme",
            eventMoodleCategory: "Moodle category"
        }
    },
	eventDescription: {
		connectedEventData: 'Connected event info',
		eventName: 'Event name',
		eventPlace: 'Event location',
		startDate: 'Start date',
		endDate: 'End date',
		project: 'Project',
		organizer: 'Organizer',
		lecturers: 'Lecturers'
    },
    dynamicLayout: {
        editPanelSize: "Edit panel size",
        size: "Size",
        enterValidValue: "Please enter a value between 1 and 12.",
        panelsVisible: "Panels visible on the page",
        eligiblePanels: "Eligible panels",
        homePageLayout: "Home Page Layout",
        removeFromPage: "Remove from visible panels on page"
    },
    responseErrors: {
        valueCannotBeNull: "Value cannot be null",
        parameterName: "Parameter name",
        objectReference: "Object reference not set to an instance of an object",
        noEventDateToSync: "No event data to sync",
        statusOfUndefined: "Cannot read property 'status' of undefined",
        networkError: "There was a problem communicating with the server"

    },
    fieldCodes: {
        title: "Field codes",
        gridHeaders: {
            fieldName: "Name",
            code: "Code",
            description: "Description",
            isForDynamicForm: "Used in forms"
        }
    },
    dinamicField: {
        gridHeaders: {
            id: "ID",
            name: "Field name",
            label: "Field label",
            fieldType: 'Field type',
            description: 'Description',
            usedIn: 'Used in',
            formId: 'Form Id'
        }
    },
    auxiliary: {
        title: 'Auxiliary registers',
        gridHeaders: {
            id: "ID",
            name: "Name",
            active: "Active"
        },
        notAuthorized: "You do not have the necessary permissions to work with @: auxiliary.title"

    },
    help: {
        menuTitle: 'User help',
        title: 'User help',
        name: 'Name',
        nameEn: "Name En",
        parent: 'Parent',
        deactivated: 'Deactivated',
        includeDeactivated: "Include deactivated",
        sort: "Sort number"
    },
    organizationalCalendarSettings: {
        title: 'Сървърни настройки за зареждане на орг. модели',
        override: 'Презаписване на настройките',
        loadOnlyValidModels: 'Зареждане на "Валидни" орг. модели',
        calendarModelsANDFilter: 'Прилагане на AND филтър',
        help: {
            override: 'Подава дефинирани от потребителя настройки за зареждане на орг. модели.',
            loadOnlyValidModels: 'Показва организационните модели избрани като шаблонни за "формата" или "дейността/направлението" на даденото събитие.',
            calendarModelsANDFilter: 'Предлагане на организационни модели според Форма на събитие И/ИЛИ Направление на събитие. Ако не е избрано ще приложи И филтър.'
        }
    },
    policy: {
        title: "Policy|Policies"
    },
    signing: {
        pageTitle: "Signing procedure|Signing procedures",
        new: "New",
        edit: "Edit",
        assignedToMe: "@:coordinations.assignedToMe",
        createdByMe: "@:coordinations.createdByMe",
        sign: "Sign",
        innerType: "Internally",
        innerTypeMessage:
            "The signing does not require an outgoing number from the record keeping system.",
        ongoing: "in process ...",
        outgoingType: "Externally",
        outgoingTypeMessage:
            "The signing requires an outgoing number from the record keeping system. The clerk must complete the procedure.",
        clerk: "Clerk",
        attachments: "Attachments",
        headers: {
            id: "ID",
            title: "@:coordinations.title",
            status: "@:coordinations.status",
            signatories: "Signatories",
            deadline: "Deadline",
            statDate: "Start date",
            creator: "Creator",
            type: "Type",
            archived: "@:coordinations.archived"
        },
        relatedTask: "Related task",
        relatedCoordination: "Related coordination",
        filesGirdHeaders: {
            fileName: "Name",
            fileDescription: "Description",
            isSigned: "Signed",
            timestampUtc: "Timestamp",
            signedBy: "Signed by"
        },
        noSignatoriesMsg: "Missing person to sign",
        startTitle: "Starting the signing procedure",
        startMessage: "Are you sure you want to start the signing procedure?",
        deletionConfirmMessage: "Are you sure you want to delete the signing procedure?",
        history: "@:tasks.history",
        details: "@:tasks.details",
        result: "@:coordinations.result",
        isSigned: "@:signing.filesGirdHeaders.isSigned",
        activities: {
            New: "set up the signing procedure",
            Edited: "edit the signing procedure",
            Canceled: "cancel the signing procedure",
            Archived: "archives the signing procedure",
            Unarchived: "unarchives the signing procedure",
            Started: "starts the signing procedure",
            Deleted: "delete the signing procedure",
            Completed: "complete the signing procedure",
        },
        signing: "@:sideMenu.signing",
        complete: "Complete",
        emptyModelError: "Empty or invalid model",
        missingSelectedAttachmentsToSign: "No documents have been selected for signing",
        completeTitle: "Completion of the signing procedure",
        completeMessage: "Are you sure you want to complete the signing procedure?",
        missingSelectedOrganizationalDocuments: "No organizational documents selected",
        organizationalDocumentsSigningCreateConfirmation: "Are you sure you want to create the signing procedure from the selected organizational documents?",
        archiveMessage: "Are you sure you want to archive this signing procedure? Once archived, it will not appear in lists and searches.",
        unarchiveMessage: `Are you sure you want to unarchive this signing procedure? Once unzipped, it will be visible in lists and searches.`,
        allowedFilesTypesForSigning: "Only .pdf and .docx files can be signed",
        createFromOrganizationalDocuments: "Create a signing procedure from the selected documents",
        unfinished: "Unfinished signing procedure",
        overdue: "overdue",
        signed: "Signed|Signed",
        unsigned: "Unsigned|Unsigned",
        started: "Started|Started",
        completed: "Completed|Completed",
        forSigning: "For signing",
    },
    accommodationRequest: {
        gridHeaders: {
            id: "ID",
            name: "Name",
            email: "E-mail",
            single: "@:accommodation.single",
            double: "@:accommodation.double",
            triple: "@:accommodation.triple",
            apartment: "@:accommodation.apartment",
            accommodationPlaceName: "@:participationConfirmation.accommodationPlace",
            accommodationPlaceNameCity: "City",
            note: "@:participationConfirmation.note",
            fromDate: "@:participationConfirmation.fromDate",
            toDate: "@:participationConfirmation.toDate",
            accommodationRequired: "@:participationConfirmation.accommodationRequired",
            vegetarianMenuRequired: "@:participationConfirmation.vegetarianMenuRequired",
            transportationRequired: "@:participationConfirmation.transportationRequired",
            confirmedByAdmin: "Confirmed by admin",
            lastUpdateDate: "Updated on",
            lastUpdater: "Updated by"
        }
    },
    deletedRecords: {
        lecturers: "Marked as deleted teachers",
        institutions: "Marked as deleted institutions and organizations",
        places: "Marked as deleted venues",
        accommodationPlaces: "Marked as deleted accommodation places",
        publicOrders: "Marked as deleted public orders",
        projects: "Marked as deleted projects",
        activities: "Marked as deleted activities",
        thematicAreas: "Marked as deleted thematic areas",
        administrativePositions: "Marked as deleted administrative positions",
        deletedEvents: "Events marked as deleted",
        deletedDocuments: "Учебни материали, Отчетни документи, Организационни документи, маркирани като изтрити"
    },
    confirmationRejection: {
        title: "Rejected applications for participation",
        id: "ID",
        note: "@:participationConfirmation.note",
        rejectedByAdmin: "Rejected by admin",
        user: "@:userName",
        time: "Time",
        name: "Name",
        username: "Username",
        email: "Email",
        rankingVersion: "Temp.ranking version",
        isRankingActive: "Active temp.ranking",
        confirmationDelete: "Are you shure you want to delete participation confirmation rejection for {name}?",
    },
    dataReference: {
        replacePrompt: "Please enter the ID № with which we will replace.",
        replacementHistory: {
            id: "ID",
            schemaName: "DB schema",
            tableName: "DB table",
            entityId: "Row ID",
            timestampUtc: "Creation time"
        }
    },
    clientCertificate: {
        title: "QES"
    },
    localServer: {
        title: "Local server",
        version: "Version",
        type: "Variant",
        currentInstalation: "Current installation",
        currentInstalationDescription: "The operability of the installation on the current computer is checked",
        ability: "Opportunities",
        settings: "Settings",
        check: "Check",
        instalationCheck: "Installation check",
        instalationCheckDescription: "A test signing is performed for verification",
        data: "Data",
        message: "Message",
        addData: "More information",
        parseSource: "Data",
        parseResult: "Result"
    },
    signingProcedureFiling: {
        pageTitle: "Filing attachments of signing procedures",
        file: "File",
        filed: "Filed|Filed",
        unfiled: "Unfiled|Unfiled",
        headers: {
            filingDate: "Filing date",
            filedBy: "Filed by",
            number: "N:"
        }
    },
    versionChangeMsg: "There is a change in the version of the application! Please refresh the page content.",
    deletedDocument: {
        headers: {
            docType: 'Type',
            fileName: 'File name',
            description: 'Description',
            eventId: 'Event Id',
            eventName: 'Event name',
            eventCode: 'Ecent short name',
            deletedOn: 'Deletion date',
            deletedBy: 'Deleted by'
        }
    },
    fileSelection: {
        computer: 'Computer',
        reportingDocs: 'Reporting documents',
        organizationalDocs: 'Organizational documents'
    }
};
